import { Translations } from '../models/i18n.model';

export const I18N_STRINGS_IA: Translations = {
  // login page:
  app_title: {
    de: 'Installation Agent',
    en: 'Installation Agent',
    pt: 'Agente de Instalação',
  },
  create_account: {
    de: 'Ein Konto erstellen',
    en: 'Create an account',
    pt: 'Criar uma conta',
  },
  create_account_info: {
    de: 'Füllen Sie das folgende Formular aus, um Ihr Konto zu erstellen und Ihnen Zugang zu Loctite Pulse zu geben',
    en: 'Fill out the following form to check and approve your account and give you access to Loctite Pulse',
    pt: 'Preencha o seguinte formulário para verificar e aprovar a sua conta e dar-lhe acesso ao Loctite Pulse',
  },
  username: { de: 'Benutzername', en: 'Username', pt: 'Nome de usuário' },
  password: { de: 'Passwort', en: 'Password', pt: 'Senha' },
  login_failed: {
    de: 'Die Anmeldedaten sind falsch. Bitte wenden Sie sich an <a href="service@loctite-pulse.com" target="_blank" class="linkStyle">service@loctite-pulse.com</a>, um Unterstützung zu erhalten.',
    en: 'Login details are wrong, please contact <a href="service@loctite-pulse.com" target="_blank" class="linkStyle">service@loctite-pulse.com</a> for support.',
    pt: 'Os dados de login estão incorretos. Entre em contato com <a href="service@loctite-pulse.com" target="_blank" class="linkStyle">service@loctite-pulse.com</a> para obter suporte.',
  },
  acc_blocked: {
    de: 'Dieser Account ist aktuell blockiert. \n Bitte kontaktieren Sie service@loctite-pulse.com, um ihren Account wieder freizuschalten.',
    en: 'The user account is currently blocked. \n Please contact service@loctite-pulse.com to have your account unblocked.',
    pt: 'A conta do usuário está atualmente bloqueada. \n Por favor contate service@loctite-pulse.com para ter a sua conta desbloqueada.',
  },
  role_not_authorized: {
    de: 'Benutzer hat keine zugewiesene Rolle',
    en: 'User does not have an assigned role',
    pt: 'O usuário não tem uma função atribuída',
  },
  sso_conversion_prompt_title: {
    de: 'Single Sign-On Umwandlung',
    en: 'Single Sign-On Conversion',
    pt: 'Conversão de Single Sign-On',
  },
  sso_conversion_prompt_1: {
    de: "Sie haben bereits ein Konto bei uns. Möchten Sie es in ein Single Sign-On-Konto umwandeln? Dieser einmalige Prozess ermöglicht es Ihnen, sich mit Ihren Firmenkonto über die Schaltfläche 'Mit Microsoft anmelden' einzuloggen.",
    en: "You already have an account with us. Would you like to convert it to a Single Sign-On account? This one-time process allows you to log in using your company credentials via the 'Sign in with Microsoft' button.",
    pt: "Você já tem uma conta conosco. Gostaria de convertê-la para uma conta de Single Sign-On? Este processo único permite que você faça login usando suas credenciais corporativas através do botão 'Entrar com Microsoft'.",
  },
  sso_conversion_prompt_2: {
    de: 'Bitte beachten Sie, dass diese Änderung irreversibel ist und Sie sich anschließend nicht mehr mit Ihrem Benutzernamen und Passwort anmelden können.',
    en: 'Please note, this change is irreversible and you won’t be able to log in with your username and password.',
    pt: 'Observe que essa mudança é irreversível e você não poderá mais fazer login com seu nome de usuário e senha.',
  },
  sso_conversion_submit: {
    de: 'In SSO umwandeln',
    en: 'Convert to SSO',
    pt: 'Converter para SSO',
  },
  sso_conversion_cancel: {
    de: 'Abbrechen',
    en: 'Cancel',
    pt: 'Cancelar',
  },
  pw_change_disabled_due_sso: {
    de: 'Passwortfunktionen für SSO-Konten deaktiviert.',
    en: 'Password functions disabled for SSO accounts.',
    pt: 'Funções de senha desativadas para contas SSO.',
  },
  ia_access_denied: {
    de: 'Anmeldung fehlgeschlagen. Für Unterstützung kontaktieren Sie uns bitte unter service@loctite-pulse.com',
    en: 'Login failed. For support please contact us at service@loctite-pulse.com',
    pt: 'Falha no login. Para obter suporte, entre em contato conosco em service@loctite-pulse.com',
  },
  enter_loctite: {
    de: 'Anmelden',
    en: 'Enter Loctite Pulse',
    pt: 'Entrar em Loctite Pulse',
  },
  forgot_password: {
    de: 'Passwort vergessen?',
    en: 'Forgot your Password?',
    pt: 'Esqueceu da senha?',
  },
  via_portal: {
    de: 'Über Portal anmelden',
    en: 'Login via Portal',
    pt: 'Login via Portal',
  },
  skip_login: {
    de: 'Anmeldung überspringen',
    en: 'Skip Login',
    pt: 'Pule o Login',
  },
  sign_up: {
    de: 'Noch keinen Account? Hier anmelden',
    en: 'No account yet? Sign up here',
    pt: 'Ainda não tem conta? Registre aqui',
  },
  already_account: {
    de: 'Ich habe bereits ein Konto, Log In',
    en: 'I already have an account, Log In',
    pt: 'Já tenho uma conta, Entrar',
  },
  note_for_us_residents: {
    de: 'Note for US residents',
    en: 'Note for US residents',
    pt: 'Nota para residentes dos EUA',
  },
  go_to_em: {
    de: 'Zum Equipment Monitor',
    en: 'Go to Equipment Monitor',
    pt: 'Ir para Monitor de Equipamento',
  },
  enter_ia: {
    de: 'Installation Agent öffnen',
    en: 'Enter Installation Agent',
    pt: 'Entrar em Agente de Instalação',
  },
  forgot_password_button: {
    de: 'Passwort vergessen?',
    en: 'Forgot your password?',
    pt: 'Esqueceu de sua senha?',
  },
  sign_in_with_microsoft: {
    de: 'Mit Microsoft anmelden',
    en: 'Sign in with Microsoft',
    pt: 'Iniciar sessão com a Microsoft',
  },
  send_mail: {
    de: 'Email versenden',
    en: 'Send email',
    pt: 'Enviar email',
  },
  forgot_password_title: {
    de: 'Passwort vergessen?',
    en: 'Forgot password?',
    pt: 'Esqueceu a senha?',
  },
  forgot_password_text: {
    de: 'Bitte geben Sie ihre Email-Adresse an und wir werden Ihnen Anweisungen zum Ändern Ihres Passworts zusenden.',
    en: "Enter your email address and we'll send you an email with instructions on how to set a new password.",
    pt: 'Insira seu e-mail e enviaremos uma mensagem em sua caixa postal com as instruções para definir uma nova senha.',
  },
  back_to_login: {
    de: 'Zurück zur Anmeldung',
    en: 'Back to login',
    pt: 'Voltar ao login',
  },
  check_your_email: {
    de: 'Überprüfen Sie Ihre E-Mail',
    en: 'Check your email',
    pt: 'Verifique o seu email',
  },
  inactive: { de: 'Inaktiv', en: 'Inactive', pt: '' },
  check_your_email_generic: {
    de: 'Falls die von Ihnen eingegebene E-Mail-Adresse mit einem Konto auf unserer Plattform verbunden ist, haben wir Ihnen eine E-Mail mit Anweisungen zum Zurücksetzen Ihres Passworts geschickt. Bitte prüfen Sie Ihren Posteingang und Ihren Spam-Ordner auf eine E-Mail von uns.',
    en: "If the email address you entered is associated with an account on our platform, we've sent you an email with instructions on how to reset your password. Please check your inbox and spam folder for an email from us.",
    pt: 'Se o endereço de e-mail  estiver associado a uma conta na nossa plataforma, enviaremos para a sua caixa postal instruções sobre como recuperar a sua senha. Por favor, verifique a sua caixa de entrada e pasta de spam .',
  },
  check_your_email1: {
    de: 'Wir haben Ihnen eine E-Mail geschickt an ',
    en: 'We have sent you an email to ',
    pt: 'Enviamos um e-mail para ',
  },
  check_your_email2: {
    de: '. Bitte klicken Sie auf den Link, um ein neues Passwort zu wählen.',
    en: '. Please click on the link to choose a new password.',
    pt: '. Por favor clique no link para escolher uma nova senha.',
  },
  email_not_received: {
    de: 'Ich habe keine Email erhalten.',
    en: "I haven't received an email.",
    pt: 'Não recebi um email.',
  },
  pw_changed_success: {
    de: 'Ihr Passwort wurde erfolgreich geändert, Sie können sich jetzt anmelden.',
    en: 'Your password has been successfully changed, you can now login.',
    pt: 'A sua senha foi alterada com sucesso, pode agora iniciar a sessão.',
  },
  signed_up_success: {
    de: 'Anmeldeformular erfolgreich abgeschickt.',
    en: 'Registration form successfully submitted.',
    pt: 'Formulário de registo apresentado com sucesso.',
  },
  unknown_mail: {
    de: 'Unbekannte E-Mail Adresse',
    en: 'Unknown email address',
    pt: 'Endereço de email desconhecido',
  },
  mail_send_error: {
    de: 'E-Mail konnte nicht versendet werden. Bitte versuchen Sie es später erneut.',
    en: 'Failed to send email. Please try again later.',
    pt: 'Falha ao enviar o email. Por favor, tente novamente mais tarde.',
  },

  // sign up:
  choose_password: {
    de: 'Wählen Sie Ihr Passwort',
    en: 'Choose password',
    pt: 'Escolha a senha',
  },
  repeat_password: {
    de: 'Passwort wiederholen',
    en: 'Repeat password',
    pt: 'Repetir a senha',
  },
  country: {
    de: 'Land, das Loctite Pulse Dienstleistungen erhält',
    en: 'Country to receive Loctite Pulse Services',
    pt: 'País que recebe os Serviços de  Loctite Pulse',
  },
  uscountry: {
    de: 'For US and Canada please register',
    en: 'For US and Canada please register',
    pt: 'Para os EUA e o Canadá, por favor registre-se',
  },
  notuscountry: {
    de: 'For countries outside the US or Canada, please register',
    en: 'For countries outside the US or Canada, please register',
    pt: 'Para países fora dos EUA ou Canadá, por favor registre-se',
  },
  select_country: {
    de: 'Land auswählen',
    en: 'Select Country',
    pt: 'Selecionar País',
  },
  select_customer: {
    de: 'Kunde auswählen',
    en: 'Select Customer',
    pt: 'Selecionar Cliente',
  },
  customerentity: {
    de: 'Kundenunternehmen',
    en: 'Customer Entity',
    pt: 'Divisão',
  },
  customer: { de: 'Kunde', en: 'Customer', pt: 'Cliente' },
  submit_form: {
    de: 'Formular abschicken',
    en: 'Submit form',
    pt: 'Enviar formulário',
  },
  signup_failed: {
    de: 'Registrierung fehlgeschlagen',
    en: 'Signup failed',
    pt: 'A inscrição falhou',
  },
  //system maintenance
  system_maintenance: {
    de: 'System maintenance',
    en: 'System maintenance',
    pt: 'Manutenção do sistema',
  },
  maintenance_message: {
    de: 'We are doing maintenance on Loctite Pulse, some features may not be available or look the same.',
    en: 'We are doing maintenance on Loctite Pulse, some features may not be available or look the same.',
    pt: 'Estamos em  manutenção no Loctite Pulse, algumas funcionalidades podem não estar disponíveis ou ter a mesma aparência.',
  },
  system_outage: {
    de: 'Systemausfall',
    en: 'System downtime',
    pt: 'Tempo de inatividade do sistema',
  },
  outage_message: {
    de: 'Aufgrund eines Ausfalls, ist diese App nicht vollständig zugänglich und es können nicht alle Daten aktualisiert werden. Wir entschuldigen uns für die Unannehmlichkeiten.\n\nBitte haben Sie Geduld mit uns, während wir mit höchster Priorität daran arbeiten, den Service wieder online zu bringen. Wir danken Ihnen für Ihre Geduld und Ihr Verständnis.',
    en: 'Due to a current outage, this app is not completely accessible and not all data can be updated. We apologize for the inconvenience.\n\nPlease bear with us as we work with highest priority to bring the service back online. Thank you for your patience and understanding.',
    pt: 'Devido a uma falha de energia, esta aplicação não está totalmente acessível e nem todos os dados podem ser atualizados. Pedimos desculpa pelo inconveniente.\n\nPor favor, aguarde conosco enquanto trabalhamos com a maior prioridade para trazer o serviço de volta online. Obrigado pela sua paciência e compreensão.',
  },
  understood: { de: 'Understood', en: 'Understood', pt: 'Entendido' },
  // admin approval:
  approve_user: {
    de: 'Benutzerkonto freigeben',
    en: 'Approve user account',
    pt: 'Aprovar conta de usuário',
  },
  approve_user_info: {
    de: 'Ein Benutzer hat sich für ein neues Benutzerkonto registriert. Bitte prüfen Sie die nachstehenden Informationen und gewähren oder verweigern Sie den Zugang zu Loctite Pulse.',
    en: 'A user has registered for a new user account. Please review the information below and grant or deny access to Loctite Pulse.',
    pt: 'Um usuário registrou-se para uma nova conta. Por favor reveja a informação abaixo e conceda ou negue o acesso ao Loctite Pulse.',
  },
  user_has_access_to: {
    de: 'Der Benutzer hat Zugriff auf:',
    en: 'User has access to:',
    pt: 'O usuário tem acesso a:',
  },
  EM_IA_both: {
    en: 'Equipment Monitor & Installation Agent',
    de: 'Equipment Monitor & Installation Agent',
    pt: 'Monitor de equipamentos e agente de instalação',
  },
  EM_Only: {
    en: 'Only Equipment Monitor',
    de: 'Nur Equipment Monitor',
    pt: 'Somente Monitor de equipamentos',
  },
  grant_access: {
    de: 'Zugriff gewähren',
    en: 'Grant access',
    pt: 'Permitir acesso',
  },
  deny_access: {
    de: 'Zugriff verweigern',
    en: 'Deny access',
    pt: 'Negar acesso',
  },
  access_granted_success: {
    de: 'Dem Nutzer wurde Zugriff zu LOCTITE Pulse gewährt.',
    en: 'The user has been granted access to LOCTITE Pulse.',
    pt: 'O usuário obteve acesso ao Loctite Pulse',
  },
  access_denied_success: {
    de: 'Dem Nutzer wurde Zugriff zu LOCTITE Pulse verweigert.',
    en: 'The user has been denied access to LOCTITE Pulse.',
    pt: 'O acesso ao LOCTITE Pulse foi negado ao usuário',
  },
  loading_approval_data_failed: {
    de: 'Beim Laden der Benutzerregistrierungsdaten ist ein Fehler aufgetreten. Die Freigabe wurde möglicherweise bereits bearbeitet oder ist abgelaufen. Bitte beachten Sie, dass Links zur Benutzerfreigabe nur 14 Tage lang gültig sind.',
    en: 'An error occurred while loading the user registration data. The approval may have already been processed or may have expired. Please note that user approval links are only valid for 14 days.',
    pt: 'Ocorreu um erro ao carregar os dados de registro do usuário. A aprovação pode já ter sido processada ou ter expirado. Por favor observe que os links de aprovação do usuário  são válidos por 14 dias.',
  },
  registration_processing_failed: {
    de: 'Es ist ein Fehler beim konfigurieren des Zugangs aufgetreten.',
    en: 'An error occurred while configuring the access.',
    pt: 'Ocorreu um erro ao configurar o acesso.',
  },
  // change pw:
  current_password: {
    de: 'Aktuelles Passwort',
    en: 'Current Password',
    pt: 'Senha Atual',
  },
  new_password_1: {
    de: 'Neues Passwort',
    en: 'New Password',
    pt: 'Nova Senha',
  },
  new_password_2: {
    de: 'Neues Passwort wiederholen',
    en: 'Repeat new password',
    pt: 'Repetir nova senha',
  },
  change_password_submit: {
    de: 'Neues Passwort festlegen',
    en: 'Set new password',
    pt: 'Defina a Nova Senha',
  },
  change_password_failed: {
    de: 'Passwortänderung fehlgeschlagen.',
    en: 'Password change failed.',
    pt: 'Alteração de Senha falhou',
  },
  change_password_unauthorized: {
    de: 'Dieser Link ist abgelaufen. Bitte fordern Sie einen neuen Link an, um Ihr Passwort zu ändern.',
    en: 'This link has expired. Please request a new link to change your password.',
    pt: 'Este link expirou. Por favor, solicite um novo link para alterar a sua senha.',
  },
  resend_mail: {
    de: 'E-Mail mit neuem Link anfordern.',
    en: 'Request email with new link.',
    pt: 'Solicitar email com novo link.',
  },
  passwords_must_be_equal: {
    de: 'Passwörter müssen identisch sein',
    en: 'Passwords must be identical',
    pt: 'A senhas devem ser idênticas',
  },
  pw_validation1: {
    de: 'Mindestens 12 Zeichen',
    en: 'At least 12 characters',
    pt: 'Pelo menos 12 caracteres',
  },
  pw_validation2: {
    de: 'Groß- und Kleinbuchstaben',
    en: 'Mix of uppercase and lowercase letters',
    pt: 'Mistura de letras maiúsculas e minúsculas',
  },
  pw_validation3: {
    de: 'Mindestens eine Ziffer',
    en: 'At least one digit',
    pt: 'Pelo menos um dígito',
  },
  pw_validation4: {
    de: 'Mindestens ein Sonderzeichen',
    en: 'At least one special character',
    pt: 'Pelo menos um caractere especial',
  },
  pw_validation5: {
    de: 'Passwörter stimmen nicht überein',
    en: 'Passwords do not match',
    pt: 'As senhas não correspondem',
  },
  pw_validation6: {
    de: 'Bestätigen Sie Ihr Passwort',
    en: 'Confirm your password',
    pt: 'Confirmar a sua senha',
  },
  email_validation1: {
    de: 'E-Mail Adresse ist erforderlich',
    en: 'Email address is required',
    pt: 'O endereço de correio eletrônico é obrigatório',
  },
  email_validation2: {
    de: 'E-Mail-Adresse ist ungültig',
    en: 'Email address is not valid',
    pt: 'O endereço de correio eletrônico é não é valido',
  },
  email_validation3: {
    de: 'Anfrage fehlgeschlagen. Für weitere Informationen kontaktieren Sie uns bitte unter service@loctite-pulse.com',
    en: 'Request failed. For more information please contact us at service@loctite-pulse.com',
    pt: 'A solicitação falhou. Para obter mais informações, entre em contato conosco pelo e-mail service@loctite-pulse.com',
  },
  password_whitespace_validation: {
    de: 'Leerzeichen sind nicht erlaubt',
    en: 'Empty spaces not allowed',
    pt: 'Espaços vazios não são permitidos',
  },
  customer_required: {
    de: 'Auswahl ist erforderlich',
    en: 'Selection is required',
    pt: 'A seleção é necessária',
  },
  name_validation: {
    de: 'Vorname ist erforderlich',
    en: 'Name is required',
    pt: 'Nome obrigatório',
  },
  surname_validation: {
    de: 'Nachname ist erforderlich',
    en: 'Surname is required',
    pt: 'É necessário o sobrenome',
  },
  length_validation: {
    de: 'Mindestens 3 Zeichen',
    en: 'At least 3 characters',
    pt: 'Pelo menos 3 caracteres',
  },
  // Header:
  navigation: { de: 'Navigation', en: 'Navigation', pt: 'Navegação' },
  overview: { de: 'Übersicht', en: 'Overview', pt: 'Visão Geral' },
  edit_plant: {
    de: 'Anlage bearbeiten',
    en: 'Edit plant',
    pt: 'Editar a planta',
  },
  edit_equipment: {
    de: 'Equipment bearbeiten',
    en: 'Edit equipment',
    pt: 'Editar equipamento',
  },
  edit_sensor: {
    de: 'Sensor bearbeiten',
    en: 'Edit sensor',
    pt: 'Editar sensor',
  },
  building_description_bold: {
    de: 'Innenraum',
    en: 'Indoor',
    pt: 'Interno',
  },
  building_description: {
    de: ' bestehend aus verschiedenen Etagen und Abschnitten',
    en: ' space composed of different floors and sections',
    pt: ' espaço constituído por diferentes pavimentos e seções',
  },
  area_description_bold: {
    de: 'Außenbereich',
    en: 'Outdoor',
    pt: 'Externo',
  },
  area_description: {
    de: ' bestehend aus Zonen und Straßenkreuzungen',
    en: ' space composed of zones and street crossings',
    pt: ' espaço constituído por zonas e cruzamentos',
  },

  // Home:
  welcome_to_ia: {
    de: 'Willkommen im Installation Agent',
    en: 'Welcome to the Installation Agent',
    pt: 'Bem-vindo ao Agente de Instalação',
  },
  lets_start: {
    de: 'Lass uns eine neue Anlage anlegen',
    en: 'Let’s start creating a new plant',
    pt: 'Vamos começar a criação de uma nova planta',
  },
  // Filter:
  filter: { de: 'Filter', en: 'Filter', pt: 'Filtro' },
  filter_plural: { de: 'Filter', en: 'Filters', pt: 'Filtros' },
  region: { de: 'Region', en: 'Region', pt: 'Região' },
  find_equipment: {
    de: 'Finde Geräte',
    en: 'Find equipment',
    pt: 'Encontrar equipamento',
  },
  show_results: {
    de: 'Ergebnisse anzeigen',
    en: 'Show results',
    pt: 'Mostrar resultados',
  },
  search: { de: 'Suche', en: 'Search', pt: 'Procurar' },
  close_search: {
    de: 'Suche schließen',
    en: 'Close Search',
    pt: 'Fechar Pesquisa',
  },
  clear_search: {
    de: 'Suche löschen',
    en: 'Clear Search',
    pt: 'Limpar Pesquisa',
  },
  clear_filter: {
    de: 'Filter löschen',
    en: 'Clear filters',
    pt: 'Limpar filtros',
  },
  status: { de: 'Status', en: 'Status', pt: 'Status' },
  all_status: { de: 'Alle Stati', en: 'All status', pt: 'Todos os status' },
  working: { de: 'Funktionsfähig', en: 'Working', pt: 'Trabalhar' },
  warning: { de: 'Warnung', en: 'Warning', pt: 'Aviso' },
  critical: { de: 'Kritisch', en: 'Critical', pt: 'Crítico' },
  equipment_type: {
    de: 'Gerätetyp',
    en: 'Equipment Type',
    pt: 'Tipo de equipamento',
  },
  flange: { de: 'Flansch', en: 'Flange', pt: 'Flange' },
  tank: { de: 'Tank', en: 'Tank', pt: 'Tanque' },
  pipe: { de: 'Rohrleitung', en: 'Pipe', pt: 'Tubulação' },
  valve: { de: 'Ventil', en: 'Valve', pt: 'Válvula' },
  steamtrap: {
    de: 'Kondensatableiter',
    en: 'Steam Trap',
    pt: 'Purgador de Vapor',
  },
  rotatingequipment: {
    de: 'Rotierende Geräte',
    en: 'Rotating Equipment',
    pt: 'Equipamento rotativo',
  },
  rotatingEqu: {
    de: 'Rot. Geräte',
    en: 'Rotating Equ.',
    pt: 'Equip. Rotativo',
  },
  steamtrap_non_abbrev: {
    de: 'Kondensat-Ableiter',
    en: 'Steam Trap',
    pt: 'Purgador de Vapor',
  },
  all_customers: {
    de: 'Alle Kunden ausgewählt',
    en: 'All customers selected',
    pt: 'Todos os clientes selecionados',
  },
  location: { de: 'Standort', en: 'Location', pt: 'Localização' },
  find_assets: {
    de: 'Finde Geräte',
    en: 'Find equipment',
    pt: 'Encontrar equipamento',
  },

  // Plant List:
  x_equipments_found: {
    de: ' Geräte gefunden.',
    en: ' equipment found',
    pt: 'equipamento encontrado',
  },
  one_equipment_found: {
    de: '1 Gerät gefunden.',
    en: '1 equipment found',
    pt: '1 equipamento encontrado',
  },
  no_equipments_found: {
    de: 'Keine Geräte gefunden.',
    en: 'No equipment found',
    pt: 'Nenhum equipamento encontrado',
  },
  x_sensors_found: {
    de: ' Sensoren gefunden.',
    en: ' sensors found',
    pt: ' sensores encontrados',
  },
  one_sensors_found: {
    de: '1 Sensor gefunden.',
    en: '1 sensor found',
    pt: '1 sensor encontrado',
  },
  no_sensors_found: {
    de: 'Keine Sensoren gefunden.',
    en: 'No sensors found',
    pt: 'Não foram encontrados sensores',
  },
  no_results_found: {
    de: 'Keine Ergebnisse gefunden.',
    en: 'No results found',
    pt: 'Nenhum resultado encontrado',
  },
  clear_search_hint: {
    de: 'Bitte Suche und Filter löschen.',
    en: 'Please clear your search and filters.',
    pt: 'Por favor, limpe a sua pesquisa e filtros.',
  },
  plant_created: {
    de: 'Die Anlage wurde erfolgreich hinzugefügt.',
    en: 'The plant has been added successfully.',
    pt: 'A planta foi adicionada com sucesso.',
  },
  create_new_plant: {
    de: 'Neue Anlage hinzufügen',
    en: 'Create a new plant',
    pt: 'Criar uma nova planta',
  },
  create_new_plant_title: {
    de: 'Erstellen wir eine neue Anlage!',
    en: 'Let’s create a new plant!',
    pt: 'Vamos criar uma nova planta!',
  },
  create_new_plant_hint: {
    de: 'Erstellen Sie eine neue Anlage, richten Sie die Struktur Ihrer Anlage ein und fügen Sie so viele Geräte und Sensoren hinzu, wie Sie benötigen.',
    en: 'Create a new plant, setup the structure of your plant and add as many equipment and sensors as you need.',
    pt: 'Criar uma nova planta, configurar a estrutura da sua planta e adicionar quantos equipamento e sensores forem necessários.',
  },

  // cards:
  sensors_in: { de: ' Sensoren in ', en: ' sensors in ', pt: ' sensores em ' },
  see_whole_plant: {
    de: 'Zur ganzen Anlage',
    en: 'See whole plant',
    pt: 'Ver planta inteira',
  },
  rename_placeholder: {
    de: 'z.B. Tank FAB105',
    en: 'e.g. Tank FAB105',
    pt: 'por exemplo, tanque FAB105',
  },

  //scroll to top component
  back_to_top: {
    de: 'Zurück zum Seitenanfang',
    en: 'Back to top',
    pt: 'Voltar ao topo',
  },

  // Plant overview:
  asset_layer_label_a: { de: 'Region', en: 'Region', pt: 'Região' },
  asset_layer_label_b: {
    de: 'Land auswählen',
    en: 'Select Country',
    pt: 'Selecionar País',
  },
  asset_layer_label_c: { de: 'Anlage', en: 'Plant', pt: 'Planta' },
  asset_layer_label_d: {
    de: 'Gebäude / Bereich',
    en: 'Building / Area',
    pt: 'Edifício / Área',
  },
  asset_layer_label_d_building: {
    de: 'Gebäude',
    en: 'Building',
    pt: 'Construção',
  },
  asset_layer_label_d_area: { de: 'Bereichsname', en: 'Area', pt: 'Área' },
  asset_layer_label_e: { de: 'Etage', en: 'Floor', pt: 'Piso' },
  asset_layer_label_f: { de: 'Abschnitt', en: 'Section', pt: 'Seção' },
  asset_layer_label_g: {
    de: 'Zugehöriges Gerät',
    en: 'Associated Equipment',
    pt: 'Equipamento Associado',
  },
  asset_layer_label_h: { de: 'Gerät', en: 'Equipment', pt: 'Equipamento' },
  asset_layer_label_i: { de: 'Sensor', en: 'Sensor', pt: 'Sensor' },
  asset_layer_label_j: { de: '---', en: '---', pt: '---' },
  asset_layer_label_k: { de: 'Bereich', en: 'Area', pt: 'Área' },
  asset_layer_label_l: { de: 'Zone', en: 'Zone', pt: 'Zona' },
  asset_layer_label_m: { de: 'Kreuzung', en: 'Crossing', pt: 'Cruzamento' },
  default_name_a: {
    de: 'Region umbenennen',
    en: 'Rename Region',
    pt: 'Mudar o nome da região',
  },
  default_name_b: {
    de: 'Land umbenennen',
    en: 'Rename Country',
    pt: 'Mudar o nome do país',
  },
  default_name_c: {
    de: 'Anlage umbenennen',
    en: 'Rename Plant',
    pt: 'Mudar o nome da planta',
  },
  default_name_d: {
    de: 'Gebäude / Bereich umbenennen',
    en: 'Rename Building / Area',
    pt: 'Mudar o Nome do Edifício / Área',
  },
  default_name_d_building: {
    de: 'Gebäude umbenennen',
    en: 'Rename Building',
    pt: 'Renomear o Edifício',
  },
  default_name_d_area: {
    de: 'Bereich umbenennen',
    en: 'Rename Area',
    pt: 'Mudar o Nome da Área',
  },
  default_name_e: {
    de: 'Etage umbenennen',
    en: 'Rename Floor',
    pt: 'Mudar o Nome do Piso',
  },
  default_name_f: {
    de: 'Abschnitt umbenennen',
    en: 'Rename Section',
    pt: 'Mudar o Nome da Seção',
  },
  default_name_g: {
    de: 'Zugehöriges Gerät umbenennen',
    en: 'Rename Associated Equipment',
    pt: 'Rename Associated Equipment',
  },
  default_name_h: {
    de: 'Gerät umbenennen',
    en: 'Rename Equipment',
    pt: 'Mudar o nome do equipamento',
  },
  default_name_i: {
    de: 'Sensor umbenennen',
    en: 'Rename Sensor',
    pt: 'Mudar o Nome do Sensor',
  },
  default_name_j: { de: '---', en: '---', pt: '---' },
  default_name_k: {
    de: 'Bereich umbenennen',
    en: 'Rename Area',
    pt: 'Mudar o Nome da Área',
  },
  default_name_l: {
    de: 'Zone umbenennen',
    en: 'Rename Zone',
    pt: 'Mudar o Nome da Zona',
  },
  default_name_m: {
    de: 'Kreuzung umbenennen',
    en: 'Rename Crossing',
    pt: 'Mudar o nome da travessia',
  },
  add_layer_a: {
    de: 'Region hinzufügen',
    en: 'Add new Region',
    pt: 'Adicionar uma nova região',
  },
  add_layer_b: {
    de: 'Land hinzufügen',
    en: 'Add new Country',
    pt: 'Adicionar um novo país',
  },
  add_layer_c: {
    de: 'Anlage hinzufügen',
    en: 'Add new Plant',
    pt: 'Adicionar uma nova planta',
  },
  add_layer_d: {
    de: 'Gebäude / Bereich hinzufügen',
    en: 'Add new Building / Area',
    pt: 'Adicionar novo Edifício / Área',
  },
  add_layer_d_building: {
    de: 'Gebäude hinzufügen',
    en: 'Add new Building',
    pt: 'Adicionar novo edifício',
  },
  add_layer_d_area: {
    de: 'Bereich hinzufügen',
    en: 'Add new Area',
    pt: 'Adicionar nova Área',
  },
  add_layer_e: {
    de: 'Etage / Zone hinzufügen',
    en: 'Add new Floor / Zone',
    pt: 'Adicionar novo piso / zona',
  },
  add_layer_f: {
    de: 'Abschnitt hinzufügen',
    en: 'Add new Section',
    pt: 'Adicionar nova Seção',
  },
  add_layer_g: {
    de: 'Zugehöriges Gerät hinzufügen',
    en: 'Add new Associated Equipment',
    pt: 'Adicionar novo equipamento associado',
  },
  add_layer_h: {
    de: 'Gerät hinzufügen',
    en: 'Add new Equipment',
    pt: 'Adicionar equipamento novo',
  },
  add_layer_i: {
    de: 'Sensor hinzufügen',
    en: 'Add new Sensor',
    pt: 'Adicionar novo Sensor',
  },
  add_layer_j: { de: '---', en: '---', pt: '---' },
  add_layer_k: {
    de: 'Bereich hinzufügen',
    en: 'Add new Area',
    pt: 'Adicionar uma nova área',
  },
  add_layer_l: {
    de: 'Zone hinzufügen',
    en: 'Add new Zone',
    pt: 'Adicionar uma nova zona',
  },
  add_layer_floor: {
    de: 'Etage hinzufügen',
    en: 'Add new Floor',
    pt: 'Adicionar novo andar',
  },
  add_layer_m: {
    de: 'Kreuzung hinzufügen',
    en: 'Add new Crossing',
    pt: 'Adicionar um novo cruzamento',
  },
  overview_hint_default: {
    de: 'Klicken Sie auf das richtige Gerät um Sensoren zu verbinden. Falls das Gerät noch nicht existiert, wählen Sie ',
    en: 'Please click on the right equipment to connect sensors. If this equipment does not exist yet, please click on ',
    pt: 'Por favor, clique no equipamento correto para ligar os sensores. Se este equipamento ainda não existir, por favor, clique no equipamento',
  },
  overview_hint_empty: {
    de: 'Fügen Sie Gebäude, Abschnitte, Geräte, etc. hinzu um die Struktur zu erstellen.',
    en: 'Please add buildings, areas, equipment, etc., to build up the structure.',
    pt: 'Adicionar edifícios, áreas, equipamento, etc., para construir a estrutura.',
  },
  overview_hint_assets: {
    de: 'Benennen Sie die verschiedenen Ebenen der Anlage und fügen Sie weitere Ebenen hinzu.',
    en: 'Name the different levels of your plant and add more levels.',
    pt: '«Digite os diferentes pisos da sua planta e acrescente mais pisos.»',
  },
  edit: { de: 'Bearbeite', en: 'Edit', pt: 'Editar' },
  edit_structure: {
    de: 'Struktur bearbeiten',
    en: 'Edit structure',
    pt: 'Editar a estrutura',
  },
  set_up_structure: {
    de: 'Struktur aufsetzen',
    en: 'Set up structure',
    pt: 'Configurar a estrutura',
  },
  set_initial_structure: {
    de: 'Struktur erstellen',
    en: 'Set structure',
    pt: 'Definir a estrutura',
  },
  finish_and_save: {
    de: 'Fertigstellen und speichern',
    en: 'Finish and save',
    pt: 'Concluir e salvar',
  },
  equipment_added: {
    de: 'Das Gerät wurde erfolgreich hinzugefügt.',
    en: 'The equipment has been added successfully.',
    pt: 'O equipamento foi adicionado com sucesso.',
  },
  buildings_added: {
    de: 'Neues Gebäude wurde hinzugefügt.',
    en: 'New building has been added.',
    pt: 'Novo edifício foi adicionado.',
  },
  areas_added: {
    de: 'Neuer Bereich wurde hinzugefügt.',
    en: 'New area has been added.',
    pt: 'Nova área foi adicionada.',
  },
  buildings_areas_not_added: {
    de: 'Keine Gebäude oder Bereiche wurden angelegt.',
    en: 'No buildings or areas were created.',
    pt: '«Não foram criados edifícios ou áreas.»',
  },
  changes_implemented: {
    de: 'Die Änderungen wurden erfolgreich eingebaut.',
    en: 'The changes have been successfully implemented',
    pt: 'As alterações foram implementadas com sucesso',
  },
  changes_not_implemented: {
    de: 'Die Änderungen wurden nicht erfolgreich eingebaut.',
    en: 'The changes have not been successfully implemented',
    pt: 'Falha na implementação das alterações',
  },
  additional_info_saved: {
    de: 'Equipment information wurden erfolgreich hinzugefügt.',
    en: 'Equipment information have been added successfully',
    pt: 'Informações sobre o equipamento foram adicionadas com sucesso',
  },
  add_building_or_area: {
    de: 'Gebäude oder Abschnitt hinzufügen',
    en: 'Add buildings or areas',
    pt: 'Adicionar edifícios ou áreas',
  },
  add_more_building_or_area: {
    de: 'Weitere Gebäude oder Abschnitte hinzufügen',
    en: 'Add more buildings or areas',
    pt: 'Adicionar mais edifícios ou áreas',
  },
  add_building_or_area_hint: {
    de: 'Erstellen Sie so viele Gebäude und Abschnitte wie nötig für ',
    en: 'Add as many buildings or areas as you need to represent ',
    pt: 'Adicionar quantos edifícios ou áreas precisar de representar ',
  },
  upload_building_plan: {
    de: 'Gebäudeplan hochladen',
    en: 'Upload the building plan',
    pt: 'Carregar a planta do edifício',
  },
  building_plan_format_a: {
    de: 'Format: .pdf',
    en: 'Format: .pdf',
    pt: 'Formato .pdf',
  },
  building_plan_format_b: {
    de: 'Max. Größe: 20MB',
    en: 'Max-size: 20MB',
    pt: 'Tamanho máximo 20MB',
  },
  view_building_plan: {
    de: 'Gebäudeplan anschauen',
    en: 'View building plan',
    pt: 'Ver planta do prédio',
  },

  // Edge device:
  edge_device_center: {
    de: 'Edge Device Center',
    en: 'Edge Device Center',
    pt: 'local do Edge Device',
  },
  show_edge_device_center: {
    de: 'Gehe zu Edge Device Center',
    en: 'Show Edge Device Center',
    pt: 'Mostrar o local do Edge Device',
  },
  problem_detected: {
    de: 'Problem detektiert',
    en: 'Problem detected',
    pt: 'Problema detectado',
  },
  last_update: {
    de: 'Letztes Update:',
    en: 'Last update:',
    pt: 'Última atualização',
  },
  check_edge_device: {
    de: 'Edge Device überprüfen',
    en: 'Check Edge Device',
    pt: 'Verificar o Edge Device',
  },
  please_check: {
    de: 'Bitte überprüfen',
    en: 'Please check',
    pt: 'Por favor verifique',
  },
  edge_device_working_fine: {
    de: 'Edge Device funktioniert',
    en: 'Edge Device working fine',
    pt: 'Edge Device funcionando corretamente',
  },
  working_fine: {
    de: 'Voll funktionsfähig',
    en: 'Working fine',
    pt: 'funcionando corretamente',
  },
  x_minutes: { de: 'x Minuten', en: 'x minutes ago', pt: 'x minutos atrás' },
  replace_edge_device: {
    de: 'Edge Device ersetzen',
    en: 'Replace edge device',
    pt: 'Substituir o Edge Device',
  },
  edge_device_problem_detected: {
    de: 'Es wurde ein Problem mit dem Edge Device festgestellt. Bitte ersetzen Sie es und gleichen Sie alle Sensoren ab, die mit diesem Edge Device verbunden sind.',
    en: 'A problem has been detected in the edge device. Please replace it and match all the sensors connected to this edge device.',
    pt: 'Foi detectado um problema no Edge Device. Por favor, substitua-o e conecte a todos os sensores ligados a este dispositivo .',
  },
  sensors_connected_to_ed: {
    de: 'Sensoren die mit dem Edge Device verbunden sind',
    en: 'Sensors connected to edge device',
    pt: 'Sensores ligados ao Edege Device',
  },
  match_sensor: {
    de: 'Sensor zuweisen',
    en: 'Match sensor',
    pt: 'Sensor pareado',
  },
  not_connected: {
    de: 'Nicht verbunden',
    en: 'Not connected',
    pt: 'Não conectado',
  },
  connected: { de: 'Verbunden', en: 'Connected', pt: 'Conectado' },
  match_all_sensors: {
    de: 'Alle Sensoren verbinden',
    en: 'Match all sensors',
    pt: 'Todos os sensores pareados',
  },

  // Asset:
  asset: { de: 'Gerät', en: 'Asset', pt: 'Ativo' },
  sensor_overview: {
    de: 'Überblick Sensoren',
    en: 'Sensor Overview',
    pt: 'Visão Geral do Sensor',
  },
  info_equipment: {
    de: 'Informationen zum Gerät',
    en: 'Information about equipment',
    pt: 'Informações sobre o equipamento',
  },
  metadata_analytics: {
    de: 'Metadaten zur Analyse',
    en: 'Metadata for analytics',
    pt: 'Metadata para análise',
  },
  error_loading: {
    de: 'Beim Laden der Informationen trat ein Fehler auf.',
    en: 'There has been an error loading the information.',
    pt: 'Houve um erro ao carregar a informação.',
  },
  connection_error: {
    de: 'Etwas ist schief gelaufen',
    en: 'Something went wrong.',
    pt: 'Algo falhou',
  },
  network_issue: {
    de: 'wiederholen',
    en: ' Retry',
    pt: 'Tente novamente',
  },
  network_issue_msg: {
    de: 'Problem mit der Internetverbindung',
    en: 'Connection Issue Detected',
    pt: 'Problema de conexão detalhada',
  },
  network_issue_content: {
    de: 'Ihre Internetverbindung scheint instabil zu sein. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
    en: 'It looks like your internet connection is unavailable. Please check your connection and try again.',
    pt: 'Parece que sua conexão com internet está indisponível. Por favor, verifique a sua conexão novamente',
  },
  network_issue_reconnect: {
    de: 'Wiederholen',
    en: 'Try to connect again',
    pt: 'Tentar conectar novamente',
  },
  add_new_sensor: {
    de: 'Neuen Sensor hinzufügen',
    en: 'Add new sensor',
    pt: 'Adicionar um novo sensor',
  },
  denial_reason: {
    en: 'Please provide a reason for denying this access request.',
    de: '', //No translations needed, its only in EN,
    pt: '',
  },
  required_field: {
    en: 'This field is required.', //No translations needed, its only in EN
    de: '',
    pt: '',
  },
  explain_text: {
    en: 'Please explain why you are denying access...',
    de: '',
    pt: '',
  },
  add_information: {
    de: 'Information hinzufügen',
    en: 'Add information',
    pt: 'Adicionar informação',
  },
  edit_information: {
    de: 'Information bearbeiten',
    en: 'Edit information',
    pt: 'Editar informação',
  },
  asset_not_found: {
    de: 'Gerät nicht gefunden :(',
    en: 'Equipment not found :(',
    pt: 'Equipamento não encontrado :(',
  },

  // Asset - Additional Info:
  add_field: { de: 'Feld hinzufügen', en: 'Add field', pt: 'Adicionar campo' },
  optional: { de: 'optional', en: 'optional', pt: 'opcional' },
  required_hint_1: {
    de: 'Bitte füllen Sie alle mit "',
    en: 'Please fill in all required fields marked with “',
    pt: 'Por favor, preencha todos os campos obrigatórios marcados com "',
  },
  required_hint_2: {
    de: '" gekennzeichneten Pflichtfelder aus, um fortfahren zu können.',
    en: '” to be able to continue.',
    pt: '” para poder continuar.',
  },
  missing_information: {
    de: 'Bitte geben Sie die fehlenden Informationen ein',
    en: 'Please provide missing information',
    pt: 'Por favor, forneça as informações em faltantes',
  },
  missing_information_message: {
    de: 'Um einen Sensor hinzuzufügen, müssen Sie zunächst die unteren Geräteinformationen hinzufügen.',
    en: 'In order to add a sensor you must first add the equipment information below.',
    pt: 'Para adicionar um sensor, deve primeiro adicionar a informação do equipamento abaixo.',
  },
  additional_information_header: {
    de: 'Zusätzliche Informationen',
    en: 'Additional Information',
    pt: 'Informações Adicionais',
  },
  ready_for_sensor_message: {
    de: 'Bereit Sensoren hinzuzufügen',
    en: 'Ready to add sensor',
    pt: 'Pronto para adicionar o sensor',
  },
  match_rotating_equipment: {
    de: 'Gerät zuordnen',
    en: 'Match Equipment',
    pt: 'Equipamento encontrado',
  },
  match_equipment_text: {
    de: 'Um Ihre Geräte richtig überwachen zu können, müssen sie richtig vernetzt sein.',
    en: 'To be able to monitor your equipment correctly, it must be linked properly.',
    pt: 'Para poder monitorar corretamente o seu equipamento, este deve estar devidamente ligado.',
  },
  match_mandatory_text1: {
    de: 'Bitte füllen Sie alle mit',
    en: 'Please fill in all required fields mark with',
    pt: 'Por favor, preencha todos os campos obrigatórios ',
  },
  match_mandatory_text2: {
    de: 'gekennzeichneten Pflichtfelder aus, um fortfahren zu können.',
    en: 'to be able to continue.',
    pt: 'para poder continuar.',
  },
  // Sensor:
  sensor_not_found: {
    de: 'Sensor nicht gefunden :(',
    en: 'Sensor not found :(',
    pt: 'Sensor não encontrado :(',
  },
  sensor_installation_data: {
    de: 'Sensor-Installationsdaten',
    en: 'Sensor installation data',
    pt: 'Dados de instalação do sensor',
  },
  sensor_name_install_data: {
    de: 'SENSORNAME',
    en: 'SENSOR NAME',
    pt: 'NOME DO SENSOR',
  },
  sensor_number_install_data: {
    de: 'SENSORNUMMER',
    en: 'SENSOR NUMBER',
    pt: 'NÚMERO DO SENSOR',
  },
  inlet_sensor_number_install_data: {
    de: 'EINLASS-NUMMER',
    en: 'SENSOR INLET NUMBER',
    pt: 'NÚMERO  DO SENSOR DE ENTRADA',
  },
  outlet_sensor_number_install_data: {
    de: 'AUSLASS-NUMMER',
    en: 'SENSOR OUTLET NUMBER',
    pt: 'NÚMERO DO SENSOR DE SAÍDA',
  },
  gateway_number_install_data: {
    de: 'GATEWAY-CODE',
    en: 'GATEWAY CODE',
    pt: 'CÓDIGO DO GATEWAY',
  },
  inlet_gateway_number_install_data: {
    de: 'Eingang GATEWAY-CODE',
    en: 'Inlet GATEWAY CODE',
    pt: 'CÓDIGO DO GATEWAY',
  },
  outlet_gateway_number_install_data: {
    de: 'Ausgang GATEWAY-CODE',
    en: 'Outlet GATEWAY CODE',
    pt: 'CÓDIGO DO GATEWAY',
  },
  dau_number_install_data: {
    de: 'DAU-CODE',
    en: 'DAU CODE',
    pt: 'CÓDIGO DAU',
  },
  inlet_dau_number_install_data: {
    de: 'Eingang DAU-CODE',
    en: 'Inlet DAU CODE',
    pt: 'CÓDIGO DAU',
  },
  outlet_dau_number_install_data: {
    de: 'Ausgang DAU-CODE',
    en: 'Outlet DAU CODE',
    pt: 'CÓDIGO DAU',
  },
  edge_device_number_install_data: {
    de: 'EDGEDEVICE-NUMMER',
    en: 'EDGE DEVICE NUMBER',
    pt: 'NÚMERO DO EDGE DEVICE',
  },
  junction_box_slot_install_data: {
    de: 'JUNCTION BOX',
    en: 'JUNCTION BOX',
    pt: 'JUNCTION BOX',
  },
  additional_documents: {
    de: 'Zusätzliche Dokumente',
    en: 'Additional Documents',
    pt: 'Documentos Adicionais',
  },
  change_file: { de: 'Datei ändern', en: 'Change file', pt: 'Alterar arquivo' },
  upload_file: {
    de: 'Datei hochladen',
    en: 'Upload a file',
    pt: 'carregar um arquivo',
  },
  file_format: {
    de: 'Format: .xlsx, .docx, .pptx, .pdf',
    en: 'Format: .xlsx, .docx, .pptx, .pdf',
    pt: 'Formato .xlsx, .docx, .pptx, .pdf',
  },
  file_size: {
    de: 'Max. Größe: 20MB',
    en: 'Max-size: 20MB',
    pt: 'Tamanho máximo 20MB',
  },
  sensor_details: {
    de: 'Sensor Details',
    en: 'Sensor details',
    pt: 'Detalhes do sensor',
  },
  sensor_photo: { de: 'Sensor Foto', en: 'Sensor photo', pt: 'Foto do Sensor' },
  reconnect_sensor: {
    de: 'Sensor neu verbinden',
    en: 'Reconnect Sensor',
    pt: 'Reconectar o Sensor',
  },
  delete_sensor: {
    de: 'Sensor löschen',
    en: 'Delete Sensor',
    pt: 'Deletar o Sensor',
  },
  document_name: {
    de: 'Dokumentenname',
    en: 'Document name',
    pt: 'Nome do documento',
  },
  placeholder_sensor_document: {
    de: 'z. B. Betriebsanleitungen',
    en: 'e.g. Operating instructions',
    pt: 'por exemplo, instruções de utilização',
  },
  junction_box_error_msg: {
    de: 'Bitte füllen Sie alle Pflichtfelder aus',
    en: 'Please fill in all mandatory fields',
    pt: 'Por favor, preencha todos os campos obrigatórios',
  },

  // Add Equipment
  add_equipment: {
    de: 'Gerät hinzufügen',
    en: 'Add equipment',
    pt: 'Adicionar equipamento',
  },
  add_equipment_hint: {
    de: 'Füllen Sie die Informationen zum Gerät aus.',
    en: 'Fill out the information about the equipment.',
    pt: 'Preencha as informações sobre o equipamento.',
  },
  add_equipment_details: {
    de: 'Gerätedetails',
    en: 'Equipment details',
    pt: 'Detalhes do equipamento',
  },
  add_equipment_type: {
    de: 'Gerätetyp',
    en: 'Equipment type',
    pt: 'Tipo de equipamento',
  },
  add_equipment_name: {
    de: 'Name des Geräts',
    en: 'Equipment name',
    pt: 'Nome do equipamento',
  },
  equipment_name_placeholder: {
    de: 'z.B. ',
    en: 'e.g. ',
    pt: 'e.g. ',
  },
  equipment_photo: {
    de: 'Foto des Geräts',
    en: 'Equipment photo',
    pt: 'Foto do Equipamento',
  },
  equipment_photo_hint: {
    de: 'Bitte fügen Sie ein Foto des Geräts hinzu, an dem die Sensoren installiert werden.',
    en: 'Please take a photo of the equipment where the sensors will be installed.',
    pt: 'Por favor tirar uma foto do equipamento onde serão instalados os sensores.',
  },
  how_will_the_photo_look: {
    de: 'Wie soll das Foto aussehen?',
    en: 'How will the photo look like?',
    pt: 'Como é que vai ficar a foto ?',
  },
  how_the_photo_will_look: {
    de: 'Wie soll das Foto aussehen?',
    en: 'How the photo will look like?',
    pt: 'Como é que vai fica a  foto ?',
  },
  change_photo: { de: 'Foto ändern', en: 'Change photo', pt: 'Mudar a foto' },
  edit_photo: { de: 'Foto ändern', en: 'Edit photo', pt: 'Editar foto' },
  mark_sensor_on_photo: {
    de: 'Sensor auf dem Foto markieren',
    en: 'Mark sensor on the photo',
    pt: 'Marcar sensor na foto',
  },
  upload_photo: {
    de: 'Foto hinzufügen',
    en: 'Upload a photo',
    pt: 'Carregar uma foto',
  },
  take_or_upload_photo: {
    de: 'Foto hinzufügen',
    en: 'Take or upload a photo',
    pt: 'Tirar ou carregar uma foto',
  },
  take_photo: {
    de: 'Foto hinzufügen',
    en: 'Take a photo',
    pt: 'Tira uma foto',
  },
  photo_format: {
    de: 'Format: .jpg, .jpeg, .png',
    en: 'Format: .jpg, .jpeg, .png',
    pt: 'Formato .jpg, .jpeg, .png',
  },
  photo_size: {
    de: 'Max. Größe: 20MB',
    en: 'Max-size: 20MB',
    pt: 'Tamanho máximo 20MB',
  },
  use_as_default: {
    de: 'Standardbild verwenden',
    en: 'Use a default photo',
    pt: 'Usar uma foto padrão',
  },
  select_a_photo: {
    de: 'Standardbild verwenden',
    en: 'Select a default photo',
    pt: 'Selecionar uma foto pré-definida',
  },
  remove_photo: {
    de: 'Foto entfernen',
    en: 'Remove photo',
    pt: 'Remover a foto',
  },
  finish_equipment: {
    de: 'Fertigstellen und Gerät hinzufügen',
    en: 'Finish and add equipment',
    pt: 'Finalizar e adicionar equipamento',
  },
  photo_example_equipment: {
    de: 'Beispielfoto Gerät',
    en: 'Example of equipment photo',
    pt: 'Exemplo de foto do equipamento',
  },
  centrifuge: { de: 'Zentrifuge', en: 'Centrifuge', pt: 'Centrífuga' },
  compressor: { de: 'Kompressor', en: 'Compressor', pt: 'Compressor' },
  electronical_motor: {
    de: 'Elektronischer Motor',
    en: 'Electronical motor',
    pt: 'Motor elétrico',
  },
  fans_and_blowers: {
    de: 'Ventilatoren und Gebläse',
    en: 'Fans and blowers',
    pt: 'Ventilador e Exaustor',
  },
  gear_drivers: {
    de: 'Getriebetreiber',
    en: 'Gear drivers',
    pt: 'Caixa de transmissão',
  },
  pump: { de: 'Pumpe', en: 'Pump', pt: 'Bomba' },
  rotating_other: { de: 'Sonstige', en: 'Other', pt: 'Outro' },
  rotatingeq_photo_selection_title: {
    de: 'Wählen Sie ein Standardfoto, das am besten zu Ihrem Drehgerät passt.',
    en: 'Select a standard photo that best suits your rotary equipment.',
    pt: 'Selecione uma foto padrão que melhor se adapte ao seu equipamento .',
  },
  save_image: {
    de: 'Bild speichern',
    en: 'Save image',
    pt: 'Salvar imagem',
  },
  photo_example_equipment_rotating_eq: {
    de: 'Beispielfoto für ein rotierendes Gerät',
    en: 'Example of rotating euqipment photo',
    pt: 'Exemplo de foto de equipamento',
  },
  // Popup
  got_it: { de: 'Okay!', en: 'Got it!', pt: 'Entendi!' },
  exit_process: {
    de: 'Vorgang beenden',
    en: 'Exit process',
    pt: 'Processo de saída',
  },
  exit: { de: 'Beenden', en: 'Exit', pt: 'Saída' },
  do_exit: {
    de: 'Wollen sie den Vorgang beenden?',
    en: 'Do you want to exit the process?',
    pt: 'Deseja sair do processo?',
  },
  do_exit_areabuildingsetup: {
    de: 'Wollen Sie das Aufsetzen der Anlagenstruktur beenden?',
    en: 'Do you want to exit setting up the structure of the plant?',
    pt: 'Quer sair e montar a estrutura da planta?',
  },
  do_exit_hint: {
    de: 'Wenn Sie den Vorgang jetzt beenden, gehen Ihre Änderungen verloren.',
    en: 'If you leave now, the changes you have made will be lost.',
    pt: 'Se sair agora, suas alterações não serão salvas',
  },
  do_exit_hint_areabuildingsetup: {
    de: 'Wenn Sie den Vorgang beenden werden die Informationen automatisch gespeichert und Sie können später weitermachen.',
    en: "If you exit, don't worry about the information, it will be automatically saved and you can continue later.",
    pt: 'se sair agora, não se preocupe , pois as informações serão salvas automaticamente',
  },
  no_stay: { de: 'Nein, bleiben', en: 'No, stay', pt: 'Não, permaneça' },
  yes_exit: { de: 'Ja, verlassen', en: 'Yes, exit', pt: 'Sim, sair' },
  where_is_qr_code: {
    de: 'Wo ist der QR Code?',
    en: 'Where is the QR code?',
    pt: 'Onde está o código QR?',
  },
  want_to_delete_1: {
    de: 'Wollen Sie ',
    en: 'Do you want to delete ',
    pt: 'Deseja eliminar ',
  },
  want_to_delete_2: { de: '?', en: '?', pt: '?' },
  delete_hint_equipment: {
    de: 'Möchten Sie Gerät ',
    en: 'Do you want to delete equipment ',
    pt: 'Deseja eliminar o equipamento',
  },
  delete_equipment_subtitle_hint: {
    de: 'Wenn Sie das Gerät löschen, verlieren Sie alle zugehörigen Informationen.',
    en: 'If you delete the equipment, you will lose all associated information.',
    pt: 'Se eliminar o equipamento, perderá toda informação associada',
  },
  delete_sensor_subtitle_hint: {
    de: 'Wenn Sie den Sensor löschen, verlieren Sie alle zugehörigen Informationen.',
    en: 'If you delete the sensor, you will loose all associated information.',
    pt: 'Se eliminar o equipamento, irá perder toda informação associada',
  },
  delete_hint_plant: {
    de: 'Sind Sie sicher, dass Sie diese Anlage dauerhaft löschen möchten',
    en: 'Are you sure you want to delete this plant permanently',
    pt: 'Tem a certeza que quer eliminar esta fábrica permanentemente',
  },
  delete_hint_building: {
    de: 'Sind Sie sicher, dass Sie dieses Gebäude dauerhaft löschen möchten',
    en: 'Are you sure you want to delete this building permanently',
    pt: 'Tem a certeza em  apagar este edifício permanentemente',
  },
  delete_hint_area: {
    de: 'Sind Sie sicher, dass Sie diesen Bereich dauerhaft löschen möchten',
    en: 'Are you sure you want to delete this area permanently',
    pt: 'Tem a certeza em  eliminar esta área permanentemente',
  },
  delete_hint_floor: {
    de: 'Sind Sie sicher, dass Sie diese Etage dauerhaft löschen möchten',
    en: 'Are you sure you want to delete this floor permanently',
    pt: 'Tem a certeza em  apagar este andar permanentemente',
  },
  delete_hint_section: {
    de: 'Sind Sie sicher, dass Sie diesen Abschnitt dauerhaft löschen möchten',
    en: 'Are you sure you want to delete this section permanently',
    pt: 'Tem a certeza que pretende eliminar esta seção permanentemente',
  },
  delete_hint_associatedeq: {
    de: 'Sind Sie sicher, dass Sie dieses zugeordnete Gerät dauerhaft löschen möchten',
    en: 'Are you sure you want to delete this associated equipment permanently',
    pt: 'Tem eliminar certeza equipamento, pretende eliminar informação associada',
  },
  delete_hint_zone: {
    de: 'Sind Sie sicher, dass Sie diese Zone dauerhaft löschen möchten',
    en: 'Are you sure you want to delete this zone permanently',
    pt: 'Tem a certeza em  eliminar esta zona permanentemente',
  },
  delete_hint_scrossing: {
    de: 'Sind Sie sicher, dass Sie diese Straßenkreuzung dauerhaft löschen möchten',
    en: 'Are you sure you want to delete this street crossing permanently',
    pt: 'Tem a certeza que querem apagar este cruzamento permanentemente',
  },
  delete_hint_sensor: {
    de: 'Möchten Sie den Sensor ',
    en: 'Do you want to delete sensor ',
    pt: 'Deseja eliminar o equipamento',
  },
  no_keep_it: {
    de: 'Nein, behalte es',
    en: 'No, keep it',
    pt: 'Não, mantenha',
  },
  no_keep: { de: 'Nein, behalten', en: 'No, keep', pt: 'Não, manter' },
  yes_delete: {
    de: 'Ja, löschen Sie es',
    en: 'Yes, delete it',
    pt: 'Sim, eliminar',
  },
  yes_i_do: {
    de: 'Ja, ich will',
    en: 'Yes, I do',
    pt: 'Sim, eu sei',
  },
  no_use_another_dau: {
    de: 'Nein, ich verwende eine andere DAU',
    en: 'No, I use another DAU',
    pt: 'Não, eu uso outra DAU',
  },
  no_use_another_gateway: {
    de: 'Nein, ich verwende ein anderes Gateway',
    en: 'No, I use another Gateway',
    pt: 'Não, eu uso outro Gateway',
  },
  delete_sensor_confirmation: {
    de: 'Der Sensor wurde erfolgreich gelöscht',
    en: 'The sensor has been successfully deleted',
    pt: 'O sensor foi eliminado com sucesso',
  },
  delete_equipment_confirmation: {
    de: 'Das Gerät wurde erfolgreich gelöscht',
    en: 'The equipment has been successfully deleted',
    pt: 'O equipamento foi eliminado com sucesso',
  },
  go_back_to_plant_overwiew: {
    de: 'Zurück zur Anlagenübersicht',
    en: 'Go back to plant overwiew ',
    pt: 'Voltar para a visão geral da planta',
  },
  go_back_to_equipment_overwiew: {
    de: 'Zurück zur Geräteübersicht',
    en: 'Go back to equipment overview',
    pt: 'Voltar para a visão geral do equipamento',
  },
  yes_delete_sensor: {
    de: 'Ja, Sensor löschen',
    en: 'Yes, delete sensor',
    pt: 'Sim, apagar sensor',
  },
  yes_delete_equipment: {
    de: 'Ja, Geräte löschen',
    en: 'Yes, delete equipment',
    pt: 'Sim, apagar equipamento',
  },
  delete_undone: {
    de: 'Dieser Schritt kann nicht rückgängig gemacht werden!',
    en: 'This step cannot be undone!',
    pt: 'Esta ação  não pode ser desfeita!',
  },
  // Create Plant
  basic_info: { de: 'Stammdaten', en: 'Basic info', pt: 'Informação Básica' },
  plant_structure_short: {
    de: 'Anlagenstruktur',
    en: 'Plant structure',
    pt: 'Estrutura da Planta',
  },
  structure: { de: 'Struktur', en: 'Structure', pt: 'Estrutura' },
  add_basic_info: {
    de: 'Anlage hinzufügen',
    en: 'Add plant',
    pt: 'Adicionar planta',
  },
  add_plant: {
    de: 'Anlage hinzufügen',
    en: 'Add plant',
    pt: 'Adicionar planta',
  },
  add_basic_info_hint: {
    de: 'Wählen Sie den Anlagennamen, weisen Sie einen Standort zu und laden Sie ein Foto hoch.',
    en: 'Select the plant name, assign a location and upload a photo.',
    pt: 'Selecione o nome da planta, atribua um local e carregue uma foto.',
  },
  add_basic_info_hint_v2: {
    de: 'Füllen Sie die Informationen über die Anlage aus.',
    en: 'Fill out the information about the plant.',
    pt: 'Preencha as informações sobre a planta.',
  },
  plant_details: {
    de: 'Details zur Anlage',
    en: 'Plant details',
    pt: 'Detalhes da planta',
  },
  plant_name: { de: 'Name der Anlage', en: 'Plant name', pt: 'Nome da planta' },
  placeholder_plant_name: {
    de: 'z.B. Düsseldorf',
    en: 'e.g. Dusseldorf',
    pt: 'e.g. Dusseldorf',
  },
  plant_photo: {
    de: 'Foto der Anlage (optional)',
    en: 'Plant photo (optional)',
    pt: 'foto da planta (facultativo)',
  },
  plant_continue: {
    de: 'Weiter zur Struktur',
    en: 'Continue to set the structure',
    pt: 'Continuar a definir a estrutura',
  },
  plant_structure: {
    de: 'Die Anlagenstruktur',
    en: 'The structure of a plant',
    pt: 'A estrutura de uma planta',
  },
  special_Characters_Not_Allowed: {
    de: 'Schrägstrich "/" ist nicht erlaubt',
    en: 'Slash "/" is not allowed',
    pt: 'A barra "/" não é permitida',
  },
  not_more_than_35_chars: {
    de: 'Nicht mehr als 35 Zeichen',
    en: 'Not more than 35 characters',
    pt: 'Não mais do que 35 caracteres',
  },
  plant_structure_hint: {
    de: 'Eine Anlage kann aus bis zu 5 hierarchisch angeordneten Ebenen bestehen:',
    en: 'A plant can have up to 5 levels arranged in a hierarchy:',
    pt: 'Uma planta pode ter até 5 níveis dispostos numa hierarquia',
  },
  basic_structure: {
    de: 'Grundstruktur',
    en: 'Basic structure',
    pt: 'Estrutura de base',
  },
  basic_structure_hint: {
    de: 'Es gibt zwei Ebenen, die in jeder Anlage enthalten sind. Die anderen drei Ebenen sind optional:',
    en: 'There are two mandatory levels. The other three levels are optional:',
    pt: 'Há dois níveis obrigatórios. Os outros três níveis são opcionais',
  },
  fully_customizable: {
    de: 'Vollständig anpassbar',
    en: 'Fully customizable',
    pt: 'Totalmente personalizável',
  },
  fully_customizable_hint: {
    de: 'Sie können die Struktur Ihren individuellen Bedürfnissen anpassen. Zum Beispiel so:',
    en: 'You can adjust the structure to your individual needs. For example like this:',
    pt: 'Você pode ajustar a estrutura às suas necessidades individuais. Como no exemplo:',
  },
  building_area: {
    de: 'Gebäude (innen) / Bereich (außen) *',
    en: 'Building (inside) / Area (outside) *',
    pt: 'Edifício (interior) / Área (exterior) *',
  },
  floor_zone: {
    de: 'Etage (Gebäude)',
    en: 'Floor (Building) / Zone (Area)',
    pt: 'Andar (prédio) / Zona (área)',
  },
  floor_zone_short: { de: 'Etage', en: 'Floor / Zone', pt: 'Andar / Zona' },
  section: { de: 'Abschnitt', en: 'Section', pt: 'Seção' },
  associated_equipment: {
    de: 'Zugehöriges Gerät',
    en: 'Associated Equipment',
    pt: 'Equipamento associado',
  },
  equipment: { de: 'Gerät *', en: 'Equipment *', pt: 'Equipamento *' },
  set_structure: {
    de: 'Festlegen der Struktur für Anlage ',
    en: 'Set the structure for plant ',
    pt: 'Definir a estrutura para a planta',
  },
  set_structure_hint: {
    de: 'Jetzt sind Sie an der Reihe! Wählen Sie die Ebenen, die Ihre Anlage enthält.',
    en: 'It’s your turn! Please select the levels that your plant contains.',
    pt: 'É a sua vez! Selecione os níveis que sua fábrica contém.',
  },
  how_is_plant_structure: {
    de: 'Wie ist eine Anlage strukturiert?',
    en: 'How is a plant structured?',
    pt: 'Como uma planta é estruturada?',
  },
  back_to_basic_info: {
    de: 'Zurück zu Stammdaten',
    en: 'Back to basic info',
    pt: 'Voltar às informações básicas',
  },
  finish_plant: {
    de: 'Fertigstellen und Anlage hinzufügen',
    en: 'Finish and add plant',
    pt: 'Finalize e adicione a planta',
  },
  save: { de: 'Speichern', en: 'Save', pt: 'Salvar' },
  save_photo: { de: 'Foto speichern', en: 'Save photo', pt: 'Salvar foto' },
  save_changes: {
    de: 'Änderungen speichern',
    en: 'Save changes',
    pt: 'Salvar alterações',
  },
  save_information: {
    de: 'Informationen speichern',
    en: 'Save information',
    pt: 'Salvar informações',
  },
  delete: { de: 'Löschen', en: 'Delete', pt: 'Deletar' },
  delete_equipment: {
    de: 'Equipment löschen',
    en: 'Delete Equipment',
    pt: 'Deletar equipamento',
  },
  delete_plant: {
    de: 'Anlage löschen',
    en: 'Delete Plant',
    pt: 'Deletar planta',
  },
  delete_area: { de: 'Bereich löschen', en: 'Delete Area', pt: 'Deletar área' },
  delete_building: {
    de: 'Gebäude löschen',
    en: 'Delete Building',
    pt: 'Deletar prédio',
  },
  delete_floor: { de: 'Etage löschen', en: 'Delete Floor', pt: 'Deletar piso' },
  delete_section: {
    de: 'Abschnitt löschen',
    en: 'Delete Section',
    pt: 'Deletar Seção',
  },
  delete_zone: { de: 'Zone löschen', en: 'Delete Zone', pt: 'Deletar zona' },
  delete_scrossing: {
    de: 'Kreuzung löschen',
    en: 'Delete Street Crossing',
    pt: 'Excluir cruzamento de rua',
  },
  delete_associatedeq: {
    de: 'Verknüpftes Gerät löschen',
    en: 'Delete Associated Equipment',
    pt: 'Deletar equipamento associado',
  },

  name_error: {
    de: 'Dieser Name wird bereits verwendet, bitte wählen Sie einen anderen Namen.',
    en: 'This name has already been used, please choose a different name.',
    pt: 'Esse nome já foi usado, escolha um nome diferente',
  },
  name_warning: {
    de: 'Dieser Name wird bereits verwendet. Sie können mit diesem Namen fortfahren oder einen anderen wählen.',
    en: 'This name has already been used. You can continue with this name or choose another one.',
    pt: 'Esse nome já foi usado. Você pode continuar com esse nome ou escolher outro.',
  },
  // Set Structure Wizard
  set_structure_title_1: {
    de: 'Befinden sich die Loctite Pulse Sensoren innerhalb von Gebäuden?',
    en: 'Are the Loctite Pulse sensors located inside buildings?',
    pt: 'Os sensores Loctite Pulse estão localizados dentro de edifícios?',
  },
  set_structure_title_1_edit_a: {
    de: 'Wollen Sie mehr Gebäude zu ',
    en: 'Do you want to add more buildings to ',
    pt: 'Deseja adicionar mais edifícios a ',
  },
  set_structure_title_1_edit_b: { de: ' hinzufügen?', en: '?', pt: '?' },
  set_structure_title_2: {
    de: 'Befinden sich die Loctite Pulse Sensoren in Außenbereichen?',
    en: 'Are the Loctite Pulse sensors located in outdoor areas?',
    pt: 'Os sensores Loctite Pulse estão localizados em áreas externas?',
  },
  set_structure_title_2_edit_a: {
    de: 'Wollen Sie mehr Außenbereiche zu ',
    en: 'Do you want to add more outdoor areas to ',
    pt: 'Você deseja adicionar mais áreas externas a ',
  },
  set_structure_title_2_edit_b: { de: ' hinzufügen?', en: '?', pt: '?' },
  set_structure_title_3_a: {
    de: 'Befinden sich die Equipment auf verschiedenen Ebenen in ',
    en: 'Are equipment located on different floors in ',
    pt: 'Os equipamento estão localizados em andares diferentes em ',
  },
  set_structure_title_3_b: { de: '?', en: '?', pt: '?' },
  set_structure_title_4: {
    de: 'Ist diese Etage in Sektionen aufgeteilt?',
    en: 'Is the shop floor divided into sections?',
    pt: 'O chão de fábrica é dividido em seções?',
  },
  set_structure_title_5: {
    de: 'Sind die zugehörigen Anlagen Teil des',
    en: 'Are associated equipment part of ',
    pt: 'Os equipamento associados fazem parte de ',
  },
  set_structure_title_6_a: { de: 'Ist ', en: 'Is ', pt: 'É ' },
  set_structure_title_6_b: {
    de: ' in Zonen aufgeteilt?',
    en: ' divided into zones?',
    pt: ' é dividido em zonas?',
  },
  set_structure_title_7: {
    de: 'Hat der Bereich mehrere Kreuzungen?',
    en: 'Does the area have multiple street crossings?',
    pt: 'A área tem vários mesmo sistema de vias?',
  },

  floor_focus: {
    de: 'Lassen Sie uns zuerst diese Etage betrachten:',
    en: 'Lets focus first on this floor:',
    pt: 'Vamos nos concentrar primeiro nesse andar:',
  },
  zone_focus: {
    de: 'Lassen Sie uns zuerst diese Zone betrachten:',
    en: "Let's focus first on this zone:",
    pt: 'Vamos nos concentrar primeiro nessa zona:',
  },
  scrossing_focus: {
    de: 'Lassen Sie uns zuerst diese Kreuzung betrachten:',
    en: "Let's focus first on this street crossing:",
    pt: 'Vamos nos concentrar primeiro nesse cruzamento de rua:',
  },
  section_focus: {
    de: 'Lassen Sie uns zuerst diese Sektion betrachten:',
    en: "Let's focus first on this section:",
    pt: 'Vamos nos concentrar primeiro nesta seção:',
  },
  floor_initial_setup_hint: {
    de: 'Nachdem Sie die Ersteinrichtung abgeschlossen haben können Sie andere Stockwerke konfigurieren.',
    en: 'After you finished the initial setup, you can configure other floors.',
    pt: 'Depois de concluir a configuração inicial, você pode configurar outros andares.',
  },
  zone_initial_setup_hint: {
    de: 'Nachdem Sie die Ersteinrichtung abgeschlossen haben können Sie andere Zonen konfigurieren.',
    en: 'After you finished the initial setup, you can configure other zones.',
    pt: 'Depois de concluir a configuração inicial, você poderá configurar outras zonas.',
  },
  scrossing_initial_setup_hint: {
    de: 'Nachdem Sie die Ersteinrichtung abgeschlossen haben können Sie andere Kreuzungen konfigurieren.',
    en: 'After you finished this setup, you can configure other street crossings.',
    pt: 'Depois de concluir essa configuração, você poderá configurar outros cruzamentos.',
  },
  section_initial_setup_hint: {
    de: 'Nachdem Sie die Ersteinrichtung abgeschlossen haben können Sie andere Sektionen konfigurieren.',
    en: 'After you finished this setup, you can configure other sections.',
    pt: 'Depois de concluir essa configuração, é possível configurar outras seções.',
  },

  equipment_hint: {
    de: 'Beispiel: Wenn der Sensor an Equipment "Flansch 01" befestigt ist und dieser Flansch Teil von "Rohr A1" ist, ist das Rohr das assoziierte Equipment.',
    en: 'Example: If the sensor is attached to the equipment “Flange 01” and this flange is part of “Pipe A1”, this pipe is the associated equipment.',
    pt: 'Se o sensor estiver conectado ao equipamento “Flange 01” e esse flange fizer parte do “Tubo A1”, esse tubo será o equipamento associado.',
  },

  no_they_are_not_buildings: {
    de: 'Nein, sind sie nicht',
    en: 'No, they are not',
    pt: 'Não, eles não são',
  },
  no_they_are_not_buildings_edit: {
    de: 'Keine weiteren Gebäude',
    en: 'No more buildings',
    pt: 'Não há mais edifícios',
  },
  no_they_are_not_areas: {
    de: 'Nein, sind sie nicht',
    en: 'No, they are not',
    pt: 'Não, eles não são',
  },
  no_they_are_not_areas_edit: {
    de: 'Keine weiteren Außenbereiche',
    en: 'No more areas',
    pt: 'Não há mais áreas',
  },
  no_they_are_not_floors: {
    de: 'Keine Etagen',
    en: 'No floors',
    pt: 'Não há andares',
  },
  no_they_are_not_sections: {
    de: 'Keine Sektionen',
    en: 'No sections',
    pt: 'Sem seções',
  },
  no_they_are_not_equipments: {
    de: 'Nein, sind sie nicht',
    en: 'No, they are not',
    pt: 'Não, eles não são',
  },
  no_they_are_not_zones: { de: 'Keine Zonen', en: 'No zones', pt: 'Sem zonas' },
  no_they_are_not_scrossings: {
    de: 'Keine Kreuzungen',
    en: 'No street crossings',
    pt: 'Sem mesmo sistema de vias',
  },

  yes_inside_buildings: {
    de: 'Ja, sie sind in Gebäuden',
    en: 'Yes, they are inside buildings',
    pt: 'Sim, eles estão dentro de edifícios',
  },
  yes_inside_buildings_edit: {
    de: 'Ja, weitere Gebäude hinzufügen',
    en: 'Yes, add more buildings',
    pt: 'Sim, adicione mais edifícios',
  },
  yes_inside_areas: {
    de: 'Ja, sie sind in Außenbereichen',
    en: 'Yes, they are in outdoor areas',
    pt: 'Sim, eles estão em áreas externas',
  },
  yes_inside_areas_edit: {
    de: 'Ja, mehr Außenbereiche hinzufügen',
    en: 'Yes, add more areas',
    pt: 'Sim, adicione mais áreas',
  },
  yes_inside_floors: {
    de: 'Ja, verschiedene Etagen',
    en: 'Yes, different floors',
    pt: 'Sim, andares diferentes',
  },
  yes_inside_sections: {
    de: 'Ja, in Sektionen aufgeteilt',
    en: 'Yes, divided in sections',
    pt: 'Sim, divididos em seções',
  },
  yes_inside_equipments: {
    de: 'Ja, sind sie',
    en: 'Yes, they are',
    pt: 'Sim, eles estão',
  },
  yes_inside_zones: {
    de: 'Ja, in Zonen aufgeteilt',
    en: 'Yes, divided into zones',
    pt: 'Sim, divididas em zonas',
  },
  yes_inside_scrossings: {
    de: 'Ja, mehrere Kreuzungen',
    en: 'Yes, multiple street crossings',
    pt: 'Sim, vários mesmo sistema de vias',
  },

  next_question: {
    de: 'Nächste Frage',
    en: 'Next question',
    pt: 'Próxima pergunta',
  },
  back_to_previous: {
    de: 'Zurück zur vorherigen Frage',
    en: 'Back to previous question',
    pt: 'Voltar à pergunta anterior',
  },

  name_buildings: {
    de: 'Bitte benennen Sie die Gebäude',
    en: 'Please name the buildings',
    pt: 'Favor nomear os edifícios',
  },
  name_areas: {
    de: 'Bitte benennen Sie die Bereiche',
    en: 'Please name the areas',
    pt: 'Favor nomear as áreas',
  },
  name_floors: {
    de: 'Bitte benennen Sie die Etagen und ordnen Sie sie von der niedrigsten zur höchsten',
    en: 'Please name the floors and arrange them from lowest to highest',
    pt: 'Favor nomear os andares e organizá-los do mais baixo ao mais alto',
  },
  name_sections: {
    de: 'Bitte benennen Sie die Sektionen',
    en: 'Please name the sections',
    pt: 'Favor nomear as seções',
  },
  name_equipments: {
    de: 'Bitte benennen Sie die assoziierten Equipment',
    en: 'Please name the associated Equipment',
    pt: 'Favor nomear os equipamentos associados',
  },
  name_zones: {
    de: 'Bitte benennen Sie die Zonen',
    en: 'Please name the zones',
    pt: 'Favor nomear as zonas',
  },
  name_scrossings: {
    de: 'Bitte benennen Sie die Kreuzungen',
    en: 'Please name the street crossings',
    pt: 'Favor nomear os cruzamentos de ruas',
  },

  building_placeholder: {
    de: 'z. B. B03 Adhesives Production',
    en: 'e.g. B03 Adhesives Production',
    pt: 'por exemplo, B03 Produção de Adesivos',
  },
  new_building_placeholder: {
    de: 'Gebäudename',
    en: 'Name of the building',
    pt: 'Nome do edifício',
  },
  new_Area_placeholder: {
    de: 'Bereichsname',
    en: 'Name of the area',
    pt: 'Nome da área',
  },
  area_placeholder: {
    de: 'z. B. Area North',
    en: 'e.g. Area North',
    pt: 'por exemplo, Área Norte',
  },
  floor_placeholder: {
    de: 'z. B. Third',
    en: 'e.g. Third',
    pt: 'Por exemplo, terceiro',
  },
  section_placeholder: {
    de: 'z. B. Alpha',
    en: 'e.g. Alpha',
    pt: 'Por exemplo, Alpha',
  },
  equipment_placeholder: {
    de: 'z. B. Pipe A1',
    en: 'e.g. Pipe A1',
    pt: 'Por exemplo, tubo A1',
  },
  zones_placeholder: {
    de: 'z. B. AN-PIPE-OUT-243',
    en: 'e.g. AN-PIPE-OUT-243',
    pt: 'Por exemplo AN-PIPE-OUT-243',
  },
  scrossing_placeholder: {
    de: 'z. B. 2022 (crosses street 20 next to 22)',
    en: 'e.g. 2022 (crosses street 20 next to 22)',
    pt: 'Por exemplo  2022 (cruza a rua 20 ao lado da 22)',
  },

  building_name: {
    de: 'Name des Gebäudes',
    en: 'Building name',
    pt: 'Nome do edifício',
  },
  building_name_edit: {
    de: 'Neues Gebäude',
    en: 'New building',
    pt: 'Novo edifício',
  },
  area_name: { de: 'Name des Bereichs', en: 'Area name', pt: 'Nome da área' },
  area_name_edit: { de: 'Neuer Bereich', en: 'New area', pt: 'Nova área' },
  floor_name: { de: 'Name der Etage', en: 'Floor name', pt: 'Nome do andar' },
  section_name: {
    de: 'Name der Sektion',
    en: 'Section name',
    pt: 'Nome da seção',
  },
  equipment_name: {
    de: 'Name des assoziierten Equipment',
    en: 'Associated equipment name ',
    pt: 'Nome do equipamento associado',
  },
  zone_name: { de: 'Name der Zone', en: 'Zone name ', pt: 'Nome da zona' },
  crossing: { de: 'der Kreuzung', en: 'crossing', pt: 'um mesmo sistema' },
  scrossing_name: {
    de: 'Name der Kreuzung',
    en: 'Street crossing name ',
    pt: 'Nome do cruzamento da rua',
  },

  building_already_added: {
    de: 'Bereits hinzugefügte Gebäude',
    en: 'Buildings already added',
    pt: 'Edifícios já adicionados',
  },
  area_already_added: {
    de: 'Bereits hinzugefügte Bereiche',
    en: 'Areas already added',
    pt: 'Áreas já adicionadas',
  },
  building: { de: 'Gebäude', en: 'Building', pt: 'Edifício' },
  area: { de: 'Bereich', en: 'Area', pt: 'Área' },
  add_building: {
    de: 'Gebäude hinzufügen',
    en: 'Add building',
    pt: 'Adicionar edifício',
  },
  add_area: { de: 'Bereich hinzufügen', en: 'Add area', pt: 'Adicionar área' },
  add_floor: {
    de: 'Eine weitere Etage hinzufügen',
    en: 'Add another floor',
    pt: 'Adicionar outro andar',
  },
  add_section: {
    de: 'Eine weitere Sektion hinzufügen',
    en: 'Add another section',
    pt: 'Adicionar outra seção',
  },
  add_as_equipment: {
    de: 'Ein weiteres assoziiertes Equipment hinzufügen',
    en: 'Add another associated equip.',
    pt: 'Adicionar outro equipamento associado',
  },
  add_zone: {
    de: 'Eine weitere Zone hinzufügen',
    en: 'Add another zone',
    pt: 'Adicionar outra zona',
  },
  add_scrossing: {
    de: 'Eine weitere Straßenkreuzung hinzufügen',
    en: 'Add another street crossing',
    pt: 'Adicionar outro cruzamento de rua',
  },

  // Connect Sensor
  add_sensor: {
    de: 'Neuen Sensor zum Gerät',
    en: 'Add a new sensor to the ',
    pt: 'Adicionar um novo sensor à seção ',
  },
  htst_sensor: {
    de: 'Fügen Sie dem Gerät neue Sensoren hinzu',
    en: 'Add new sensors to the equipment',
    pt: 'Adicione novos sensores ao equipamento',
  },
  add_sensor_equipment: {
    de: 'Neuen Sensor zum Gerät',
    en: 'Add new sensors to the equipment',
    pt: 'Adicionar um novo sensor à seção ',
  },
  add_sensor_hint: {
    de: 'Sobald der Sensor physisch am Gerät installiert wurde, muss er mit Loctite Pulse verknüpft werden um die Messdaten zu visualisieren.',
    en: 'Once the sensor is installed on the physical equipment, we need to connect it to Loctite Pulse in order to visualize the sensor data.',
    pt: 'Depois que o sensor estiver instalado no equipamento físico, precisamos conectá-lo ao Loctite Pulse para visualizar os dados do sensor.',
  },
  add_sensor_hint_cont: {
    de: 'Diesen Vorgang werden wir in den folgenden Schritten beginnen:',
    en: 'This is the process we are going to start next by following these steps:',
    pt: 'Este é o processo que iniciaremos a seguir, seguindo estas etapas',
  },
  sensor_step_1: {
    de: 'Sensor in Loctite Pulse registrieren',
    en: 'Register sensor in Loctite Pulse',
    pt: 'Registre o sensor no Loctite Pulse',
  },
  sensor_step_2: {
    de: 'Sensor mit Edge Device verbinden',
    en: 'Match edge device to sensor',
    pt: 'Associe o edge device com o sensor',
  },
  sensor_step_3: {
    de: 'Foto des Sensors und des Equipment hochladen',
    en: 'Upload photo of sensor and equipment',
    pt: 'Carregar foto do sensor e do equipamento',
  },
  sensor_step_3_mobile: {
    de: 'Foto des Sensors und des Equipment aufnehmen',
    en: 'Take photo of sensor and equipment',
    pt: 'Tirar foto do sensor e do equipamento',
  },
  sensor_step_inlet: {
    de: 'Eingang-Sensor registrieren',
    en: 'INLET: Register sensor',
    pt: 'Registrar o sensor INLET',
  },
  sensor_step_outlet: {
    de: 'Ausgang-Sensor registrieren',
    en: 'OUTLET: Register sensor',
    pt: 'Registrar sensor OUTLET',
  },
  sensor_step_DAU: {
    de: 'QR für DAU scannen',
    en: 'Scan QR for DAU',
    pt: 'Escanear QR para DAU',
  },
  sensor_step_gateway: {
    de: 'Matrixcode des Gateways scannen ',
    en: 'Scan matrix code of Gateway ',
    pt: 'Digitalizar código de matriz do Gateway ',
  },
  sensor_step_connect: {
    de: 'Verbindung prüfen',
    en: 'Check connectivity',
    pt: 'Verificar a conectividade',
  },
  add_inlet_gateway: {
    de: 'Gateway scannen',
    en: ' Scan gateway',
    pt: 'Scan gateway',
  },
  add_outlet_gateway: {
    de: 'Gateway scannen',
    en: ' Scan gateway',
    pt: 'Scan gateway',
  },
  add_inlet_DAU: {
    de: 'DAU scannen',
    en: 'Scan DAU',
    pt: 'Scan DAU',
  },
  inlet_sensor_header: {
    de: 'EINGANG-Sensor',
    en: 'INLET Sensor',
    pt: 'INLET Sensor',
  },
  outlet_sensor_header: {
    de: 'AUSGANG-Sensor',
    en: 'OUTLET Sensor',
    pt: 'OUTLET Sensor',
  },
  Inlet_Sensor: {
    de: 'Eingang-Sensor',
    en: 'Inlet Sensor',
    pt: 'Inlet Sensor',
  },
  Outlet_Sensor: {
    de: 'Ausgang-Sensor',
    en: 'Outlet Sensor',
    pt: 'Outlet Sensor',
  },
  add_outlet_DAU: {
    de: 'DAU scannen',
    en: 'Scan DAU',
    pt: 'Scan DAU',
  },
  sensor_installation_date: {
    en: 'SENSOR INSTALLATION DATE',
    de: 'DATUM DER SENSORINSTALLATION',
    pt: 'DATA DE INSTALAÇÃO DO SENSOR',
  },
  sensor_selecting_DAU: {
    de: 'Wählen Sie das richtige DAU',
    en: 'Select the right DAU',
    pt: 'Selecione a DAU correta',
  },
  select_right_DAU: {
    de: 'Bitte wählen Sie das richtige DAU',
    en: 'Please select the correct DAU',
    pt: 'Selecione a DAU correta',
  },
  dau_look_like: {
    de: 'Wie sehen die DAUs aus?',
    en: 'How does the DAUs look like?',
    pt: 'Como são as DAUs?',
  },
  two_sensor_dau: {
    de: '2-Sensor-DAU',
    en: '2 sensor DAU',
    pt: 'DAU de 2 sensores',
  },
  four_sensor_dau: {
    de: '4-Sensor-DAU',
    en: '4 sensor DAU',
    pt: 'DAU de 4 sensores',
  },
  sensor_step_photo: {
    de: 'Installierten Sensor fotografieren',
    en: 'Upload photo of sensor installed',
    pt: 'Tirar foto do sensor instalado',
  },
  inlet: { de: 'Eingang', en: 'INLET', pt: 'Entrada' },
  outlet: { de: 'Ausgang', en: 'OUTLET', pt: 'Saída' },
  DAU: { de: 'DAU', en: 'DAU', pt: 'DAU' },
  inlet_dau: { de: 'EINGANG DAU', en: 'INLET DAU', pt: 'INLET DAU' },
  color_red: { de: 'Rot', en: 'Red', pt: 'Vermelho' },
  color_green: { de: 'Grün', en: 'Green', pt: 'Verde' },
  color_blue: { de: 'Blau', en: 'Blue', pt: 'Azul' },
  color_black: { de: 'Schwarz', en: 'Black', pt: 'Preto' },
  outlet_dau: { de: 'AUSGANG DAU', en: 'OUTLET DAU', pt: 'OUTLET DAU' },
  gateway: { de: 'Gateway', en: 'Gateway', pt: 'Gateway' },
  inlet_gateway: {
    de: 'EINGANG Gateway',
    en: 'INLET Gateway',
    pt: 'INLET Gateway',
  },
  outlet_gateway: {
    de: 'AUSGANG Gateway',
    en: 'OUTLET Gateway',
    pt: 'OUTLET Gateway',
  },
  connect: { de: 'Verbinden', en: 'Connect', pt: 'Conectar' },
  register_sensor: {
    de: 'Sensor registrieren',
    en: 'Register sensor',
    pt: 'Registre o sensor',
  },
  DAU_scan_MAC: {
    de: 'MAC-Adresse der DAU scannen',
    en: 'Scan MAC address of DAU',
    pt: 'Escanear o endereço MAC da DAU',
  },
  DAU_scan_MAC_INLET: {
    de: 'MAC-Adresse der DAU scannen: EINGANG',
    en: 'Scan MAC address of DAU: INLET',
    pt: 'Escanear o endereço MAC da DAU: INLET',
  },
  DAU_scan_MAC_OUTLET: {
    de: 'MAC-Adresse der DAU scannen: AUSGANG',
    en: 'Scan MAC address of DAU: OUTLET',
    pt: 'Escanear o endereço MAC da DAU: OUTLET',
  },
  DAU_scan_MAC_hint: {
    de: 'Bitte scannen Sie den QR Code der Datenerfassungseinheit „Data Acquisition Unit“ (DAU).',
    en: 'Please scan the QR Code of the DAU',
    pt: 'Favor escanear o código QR da DAU',
  },
  DAU_scan_MAC_hint_htst: {
    de: 'Bitte geben Sie den QR-Code der DAU ein',
    en: 'Please enter the QR Code of the DAU',
    pt: 'Digite o código QR da DAU',
  },
  Mac_address: {
    en: 'Mac Address',
    de: 'Mac-Adresse',
    pt: 'Endereço MAC',
  },
  dau_model: {
    en: 'Dau Model',
    de: 'DAU-Modell',
    pt: 'Modelo da DAU',
  },
  sensor_color: {
    en: 'Sensor Color',
    de: 'Sensor Farbe',
    pt: 'Cor do sensor',
  },
  gateway_htst: {
    en: 'GATEWAY ID LOCTITE PULSE ED 20 GW EU',
    de: 'GATEWAY ID LOCTITE PULSE ED 20 GW EU',
    pt: 'ID DO GATEWAY LOCTITE PULSE ED 20 GW EU',
  },
  enter_DAU: {
    de: 'Tragen Sie die 12 Ziffern hier ein:',
    en: 'Enter the 12 digits here:',
    pt: 'Digite os 12 dígitos aqui',
  },
  enter_DAU_htst: {
    de: 'Geben Sie die 12 Ziffern der MAC-Adresse ein:',
    en: 'enter the 12 digits of the MAC Address:',
    pt: 'Digite os 12 dígitos do endereço MAC:',
  },
  enter_DAU_mobile: {
    de: 'tragen Sie die 12 Ziffern hier ein:',
    en: 'enter the 12 digits here:',
    pt: 'digite os 12 dígitos aqui',
  },
  DAU_qr_code: {
    de: "DAU's QR code",
    en: "DAU's QR code",
    pt: 'Código QR da DAU',
  },
  back_to_start: {
    en: 'Back to start',
    de: 'Zurück zum Start',
    pt: 'Voltar ao início',
  },
  sensor_qr_instruction_DAU: {
    de: 'Der QR-Code befindet sich auf der kleinen roten Datenerfassungseinheit (DAU), an der die beiden Sensorkabel für Einlass und Auslass befestigt sind.',
    en: 'The QR code is located on the small red Data Acquisition Unit (DAU) where the two sensor cables for inlet and outlet are attached.',
    pt: 'O código QR está localizado na Unidade de Aquisição de Dados (DAU) vermelha, onde os dois cabos do sensor para entrada e saída estão conectados.',
  },
  enter_code_gateway: {
    de: 'Gateway Code eingeben',
    en: 'Scan the code of Gateway',
    pt: 'Digite o código da Gateway',
  },
  enter_code_gateway_hint: {
    de: 'Bitte scannen Sie den Matrix Code vom Gateway.',
    en: 'Please enter the digit from the Gateway to start the process.',
    pt: 'Digite o dígito do Gateway para iniciar o processo.',
  },
  where_is_the_matrix_code: {
    de: 'Wo ist der Matrix Code?',
    en: 'Where is the matrix code?',
    pt: 'Onde está o código da matriz?',
  },
  where_to_find_the_code: {
    de: 'Wo sind die Code zu finden?',
    en: 'Where to find the code?',
    pt: 'Onde encontrar os código?',
  },
  Where_to_find_the_codes: {
    de: 'Wo sind die Codes zu finden?',
    en: 'Where to find the codes?',
    pt: 'Onde encontrar os códigos?',
  },
  Microtronics_device: {
    de: 'Microtronics Gerät',
    en: 'Microtronics device',
    pt: 'Microtronics device',
  },
  MOXA_device: { de: 'MOXA Gerät', en: 'MOXA device', pt: 'Dispositivo MOXA' },
  loctite_pulse_ed_20_gw: {
    de: 'LOCTITE PULSE ED 20 GW EU',
    en: 'LOCTITE PULSE ED 20 GW EU',
    pt: 'LOCTITE PULSE ED 20 GW EU',
  },
  scan_device: { de: 'Gerät scannen', en: 'Scan device', pt: '' },
  scan_matrix_code: {
    de: 'Matrix code scannen',
    en: 'Scan matrix code',
    pt: 'Scan matrix code',
  },
  scan_gateway_code: {
    de: 'Scannen Sie den Code',
    en: 'Scan the code',
    pt: 'Escanear o código',
  },
  scan_moxa_device: {
    de: 'Scannen Sie MOXA Gerät',
    en: 'Scan the MOXA device',
    pt: 'Escanear o dispositivo MOXA',
  },
  scan_microtonic_device: {
    de: 'Scannen Sie Microtronics Gerät',
    en: 'Scan the Microtronic device',
    pt: 'Escaneie o Microtronic Device',
  },
  enter_matrix_code: {
    de: 'Tragen Sie die Ziffern hier ein:',
    en: 'Enter the digits here:',
    pt: 'Digite os dígitos aqui',
  },
  enter_matrix_code_mobile: {
    de: 'tragen Sie die Ziffern hier ein:',
    en: 'Enter the digits here:',
    pt: 'digite os dígitos aqui',
  },
  matrix_code_successfully_scanned: {
    de: 'Matrix Code erfolgreich gescannt',
    en: 'Matrix code successfully scanned',
    pt: 'Código de matriz escaneado com sucesso',
  },
  matrix_code_valid: {
    de: 'Matrix Code erfolgreich eingegeben',
    en: 'Matrix Code successfully entered',
    pt: 'Código de matriz inserido com sucesso',
  },
  moxa_matrix_code_valid: {
    de: 'Code erfolgreich für ein MOXA-Gerät eingegeben.',
    en: 'Code successfully entered.',
    pt: 'Código inserido com sucesso para um dispositivo MOXA',
  },
  invalid_gateway_error: {
    de: 'Bitte geben Sie ein gültiges Gateway an.',
    en: 'Please enter a valid Gateway.',
    pt: 'Digite um gateway válido.',
  },
  mt_matrix_code_valid: {
    de: 'Code erfolgreich für ein Microtronics-Gerät eingegeben.',
    en: 'Code successfully entered for a Microtronics device.',
    pt: 'Código inserido com sucesso para um dispositivo Microtronics',
  },
  exactly_sixteen_digits: {
    de: 'Genau 16 Zeichen',
    en: 'Exactly 16 characters',
    pt: 'Exatamente 16 caracteres',
  },
  maximum_four_DAUS: {
    de: 'Maximal 4 DAUs pro Gateway',
    en: 'Maximum of 4 DAUs per gateway',
    pt: 'Máximo de 4 DAUs por gateway',
  },
  maximum_five_DAUS_error: {
    de: 'Es sind bereits 5 DAUs mit diesem Gateway verbunden. Bitte verbinden Sie ein anderes Gateway.',
    en: 'There are already 5 DAUs connected to this gateway. Please connect another gateway.',
    pt: 'Já existem 5 DAUs conectadas a esse gateway. Conecte outro gateway.',
  },
  maximum_nine_DAUS_error: {
    de: 'Es sind bereits 9 DAUs mit diesem Gateway verbunden. Bitte verbinden Sie ein anderes Gateway.',
    en: 'There are already 9 DAUs connected to this gateway. Please connect another gateway.',
    pt: 'Já existem 9 DAUs conectadas a esse gateway. Conecte outro gateway.',
  },
  gateway_s_matrix_code: {
    de: 'Matrix Code für Gateway',
    en: "Gateway's matrix code",
    pt: 'Código de matriz do gateway',
  },
  matrix_code_location: {
    de: 'Der Matrix Code befindet sich auf der blauen Gateway Box. Auf der rechten Seite dieser Box finden sie einen schwarzen Sticker mit dem Code.',
    en: 'The QR code is located on the small blue box "Gateway". On the right side of the box you can find a black sticker where the QR code is located.',
    pt: 'O código QR está localizado na caixa azul “Gateway”. No lado direito da caixa, você pode encontrar um adesivo preto onde o código QR está localizado.',
  },
  matrix_code_location_moxa: {
    de: 'Der QR-Code befindet sich auf dem Loctite-Etikett auf der Vorderseite des MOXA-Gehäuses.',
    en: 'The QR code is located within the Loctite label on the front side of the MOXA casing.',
    pt: 'O código QR está localizado dentro da etiqueta Loctite na parte frontal da caixa do MOXA.',
  },
  matrix_code_location_moxa_htst: {
    de: 'Der QR-Code befindet sich auf der Oberseite des schwarzen Gehäuses, das das LOCTITE PULSE ED 20 GW EU-Gateway abdeckt,',
    en: 'The QR code is located on the upper side of the black case which is covering LOCTITE PULSE ED 20 GW EU gateway,',
    pt: 'O código QR está localizado na parte superior da caixa preta que cobre o gateway LOCTITE PULSE ED 20 GW EU,',
  },
  mac_address_of_INLET_DAU: {
    de: 'Mac-Adresse des DAUs für den EINGANG:',
    en: 'Mac address of INLET DAU:',
    pt: 'Endereço Mac da INLET DAU:',
  },
  mac_address_of_OUTLET_DAU: {
    de: 'Mac-Adresse des DAUs für den AUSGANG',
    en: 'Mac address of OUTLET DAU:',
    pt: 'Endereço Mac da OUTLET DAU:',
  },
  note: { de: 'Anmerkung: ', en: 'Note: ', pt: 'Nota: ' },
  maximum_5_Dau: {
    de: 'Maximal 5 DAUs pro Gateway für Microtronics-Geräte.',
    en: 'Maximum amount of 5 DAUs per gateway for Microtronics devices.',
    pt: 'Quantidade máxima de 5 DAUs por gateway para dispositivos Microtronics.',
  },
  maximum_9_Dau: {
    de: 'Maximal 9 DAUs pro Gateway für MOXA-Geräte.',
    en: 'Maximum amount of 9 DAUs per gateway for MOXA devices.',
    pt: 'Quantidade máxima de 9 DAUs por gateway para dispositivos MOXA.',
  },
  sensor_step_4: {
    de: 'Standort des Sensors festlegen',
    en: 'Define sensor location',
    pt: 'Definir localização do sensor',
  },
  start_process: {
    de: 'Vorgang beginnen',
    en: 'Start process',
    pt: 'Iniciar processo',
  },
  connection_error_popup_title: {
    de: 'Bitte prüfen Sie die Gateway-Verbindung',
    en: 'Please Check the Gateway connection',
    pt: 'Verifique a conexão do gateway',
  },
  connection_error_popup_instructions1: {
    de: '1. Vergewissern Sie sich, dass das Gerät an das Stromnetz angeschlossen ist.',
    en: '1. Ensure that the power supply is connected.',
    pt: '1. Certifique-se de que a fonte de alimentação esteja conectada.',
  },
  connection_error_popup_instructions2: {
    de: '2. Problem mit der Mobilfunkkonnektivität.(Benutzer kann sich an einen besseren Standort für den Empfang begeben)',
    en: '2. Cellular connectivity issue.(user can move to a better location for reception)',
    pt: '2. Problema de conectividade celular.(o usuário pode mudar para um local melhor para a recepção)',
  },
  connection_error_popup_instructions3: {
    de: '3. Gateway kann offline sein',
    en: '3. Gateway can be offline',
    pt: '3. O gateway pode estar off-line',
  },
  connection_error_popup_instructions4: {
    de: '4. Das Gateway kann ungültig sein.',
    en: '4. Gateway may be invalid.',
    pt: '4. O gateway pode ser inválido.',
  },
  register: { de: 'Registrieren', en: 'Register', pt: 'Registrar' },
  match: { de: 'Verbinden', en: 'Match', pt: 'Parear' },
  photo: { de: 'Foto', en: 'Photo', pt: 'Foto' },
  ultrasonic: { de: 'Ultraschall', en: 'Ultrasonic', pt: 'Ultrassônico' },
  register_hint: {
    de: 'Zuerst müssen wir den QR Code des Sensors scannen um zu wissen über welchen Sensor wir reden. Sie finden den QR Code auf dem Kabel.',
    en: 'First we need to scan the sensor QR that you will find on the cable to know which sensor we are talking about.',
    pt: 'Primeiro precisamos escanear o QR do sensor que você encontrará no cabo para saber de qual sensor estamos falando.',
  },
  or: { de: 'oder', en: 'or', pt: 'ou' },
  scan_qr_code: {
    de: 'QR Code scannen',
    en: 'Scan QR code',
    pt: 'Scan QR code',
  },
  scan_or_upload_code: {
    de: 'Code scannen oder hochladen',
    en: 'Scan or upload code',
    pt: 'Escanear ou carregar o código',
  },
  qr_successfully_scanned: {
    de: 'QR Code erfolgreich gescannt',
    en: 'QR code successfully scanned',
    pt: 'Código QR escaneado com sucesso',
  },
  enter_code: {
    de: 'Tragen Sie die 11 Ziffern hier ein:',
    en: 'Enter the 11 digits here:',
    pt: 'Digite os 11 dígitos aqui',
  },
  enter_code_mobile: {
    de: 'tragen Sie die 11 Ziffern hier ein:',
    en: 'enter the 11 digits here:',
    pt: 'digite os 11 dígitos aqui',
  },
  code_valid: {
    de: 'QR Code erfolgreich eingegeben',
    en: 'QR Code successfully entered',
    pt: ' Código QR inserido com sucesso',
  },
  code_invalid_scanned: {
    de: 'Der Code konnte nicht gescannt werden. Bitte versuchen Sie es erneut oder geben Sie den Code direkt ein.',
    en: 'It has not been possible to scan the code, please try again or enter the digits manually.',
    pt: 'Não foi possível escanear o código, tente novamente ou insira os dígitos manualmente.',
  },
  code_invalid_typed: {
    de: 'Der eingegebene Code ist nicht korrekt. Bitte überprüfen Sie die Anforderungen.',
    en: 'The code entered is incorrect. Please check the digit requirements.',
    pt: 'O código inserido está incorreto. Verifique os requisitos de dígitos.',
  },
  eleven_characters: {
    de: 'Genau 11 Zeichen',
    en: 'Exactly 11 characters',
    pt: 'Exatamente 11 caracteres',
  },
  twelve_characters: {
    de: 'Genau 12 Zeichen',
    en: 'Exactly 12 characters',
    pt: 'Exatamente 12 caracteres',
  },
  only_numbers: {
    de: 'Nur Ziffern.',
    en: 'Only numbers.',
    pt: 'Somente números.',
  },
  only_alphanumerical: {
    de: 'Alphanumerische Auflistung',
    en: 'Pair of twos (alphanumeric)',
    pt: 'Par de dois (alfanumérico)',
  },
  only_hexadecimal: {
    de: 'Hexadezimale Auflistung (0-9, A-F)',
    en: 'Hexadecimal pairs of two (0-9, A-F)',
    pt: 'Pares hexadecimais de dois (0-9, A-F)',
  },
  only_alphanumeric: {
    de: 'Alphanumerische Auflistung',
    en: 'Only alphanumeric',
    pt: 'Somente alfanumérico',
  },
  matches_mapping: {
    de: 'Nur registrierte Codes',
    en: 'Only registered codes',
    pt: 'Somente códigos registrados',
  },
  slot_reserved: {
    de: 'Maximal 5 DAUs pro Gateway',
    en: 'Maximum of 5 DAUs per gateway',
    pt: 'Máximo de 5 DAUs por gateway',
  },
  define_sensor_name: {
    de: 'Legen Sie einen Namen für den Sensor fest (z.B. die Position am Gerät):',
    en: 'Please define a name for the sensor (e.g. position on the Equipment):',
    pt: 'Defina um nome para o sensor (por exemplo, posição no equipamento):',
  },
  sensor_name: { de: 'Sensor Name', en: 'Sensor name', pt: 'Nome do sensor' },
  match_sensor_hint: {
    de: 'Scannen Sie jetzt den QR Code auf dem Edge Device um es mit dem Sensor aus Schritt 1 zu verbinden.',
    en: 'Now please scan the QR code on the edge device to connect it to the sensor from step 1.',
    pt: 'Agora, escaneie o código QR no dispositivoEdge Device para conectá-lo ao sensor da etapa 1.',
  },
  // photo_hint: {
  //   de: 'Perfekt, nur ein Schritt bleibt noch. Fügen Sie ein Foto des Sensors am Gerät hinzu.',
  //   en: 'Perfect, there is only one last step left, upload a photo of the sensor installed in the equipment.',
  // },
  // photo_hint_mobile: {
  //   de: 'Perfekt, nur ein Schritt bleibt noch. Fügen Sie ein Foto des Sensors am Gerät hinzu.',
  //   en: 'Perfect, there is only one last step left, take a photo of the sensor installed in the equipment.',
  // },
  photo_hint_sensor: {
    de: 'Nehmen Sie ein Foto des installierten Sensors auf oder laden Sie ein entsprechendes Foto hoch.',
    en: 'Upload a photo of the sensor installed in the equipment.',
    pt: 'Carregue uma foto do sensor instalado no equipamento.',
  },
  photo_hint_sensor_camera: {
    de: 'Nehmen Sie ein Foto des installierten Sensors auf oder laden Sie ein entsprechendes Foto hoch.',
    en: 'Take or upload a photo of the sensor installed in the equipment.',
    pt: 'Tire ou carregue uma foto do sensor instalado no equipamento.',
  },
  photo_hint_sensor_header_mobile: {
    de: 'Installierter Sensor (Detailfoto)',
    en: 'Installed sensor (detailed photo)',
    pt: 'Sensor instalado (foto detalhada)',
  },
  photo_hint_sensor_header: {
    de: 'Installierter Sensor',
    en: 'Installed sensor',
    pt: 'Sensor instalado',
  },
  photo_hint_sensor_header_2: {
    de: '(Detailfoto)',
    en: '(detailed photo)',
    pt: '(foto detalhada)',
  },
  photo_hint_equipment: {
    de: 'Bitte fügen Sie ein Foto des Geräts hinzu, an dem die Sensoren installiert werden.',
    en: 'Upload a photo of the full equipment where we can see the different sensors.',
    pt: 'Faça upload de uma foto do equipamento completo onde possamos ver os diferentes sensores.',
  },
  photo_hint_equipment_camera: {
    de: 'Bitte fügen Sie ein Foto des Geräts hinzu, an dem die Sensoren installiert werden.',
    en: 'Take or upload a photo of the full equipment where we can see the different sensors.',
    pt: 'Tire ou carregue uma foto do equipamento completo onde possamos ver os diferentes sensores.',
  },
  photo_hint_equipment_header_mobile: {
    de: 'Gerät (Übersichtsbild)',
    en: 'Equipment (overview photo)',
    pt: 'Equipamento (foto de visão geral)',
  },
  photo_hint_equipment_header: {
    de: 'Gerät',
    en: 'Equipment',
    pt: 'Equipamento',
  },
  photo_hint_equipment_header_2: {
    de: '(Übersichtsbild)',
    en: '(overview photo)',
    pt: '(foto de visão geral)',
  },
  junction_box: { de: 'Junction Box', en: 'Junction box', pt: 'Junction box' },
  junction_box_slot: {
    de: 'Junction Box Slot',
    en: 'Junction box slot',
    pt: 'Slot da Junction box',
  },
  junction_box_hint: {
    de: 'Bitte wählen Sie den Junction Box Slot aus, mit dem Sie das Sensorkabel verbunden haben: ',
    en: 'Please select the junction box slot where you plugged in the sensor cable:',
    pt: 'Selecione o slot da junction box onde você conectou o cabo do sensor:',
  },
  junction_box_channel: {
    de: 'Junction Box Channel',
    en: 'Junction Box Channel',
    pt: 'Canal da Junction Box',
  },
  junction_box_channel_drop: {
    de: 'Junction Box Channel auswählen',
    en: 'Select Junction Box Channel',
    pt: 'Selecione o canal da Junction box',
  },
  what_is_junction_box: {
    de: 'Was ist die Junction Box?',
    en: 'What is the junction box?',
    pt: 'O que é junction box?',
  },
  where_is_junction_box: {
    de: 'Wo ist der Junction Box Channel?',
    en: 'Where is the junction box channel?',
    pt: 'Onde está o canal da junction box ?',
  },
  junction_box_popup_title: {
    de: 'Wo ist die Nummer in der Junction Box zu finden?',
    en: 'Where is the number located in the Junction box?',
    pt: 'Onde está o número localizado na junction box ?',
  },
  junction_box_popup_instructions: {
    de: 'Unten finden Sie die Junction Box mit den 8 Kanälen zum Anschluss des Sensors.',
    en: 'Below you will find the function box with the 8 channels to connect the sensor.',
    pt: 'Abaixo você encontrará a caixa de função com os 8 canais para conectar o sensor.',
  },
  mark_sensor: {
    de: 'Kennzeichnen Sie den Sensor auf dem Foto',
    en: 'Mark the sensor on the photo',
    pt: 'Marque o sensor na foto',
  },
  location_hint: {
    de: 'Definieren Sie wo sich der Sensor auf der Karte befindet.',
    en: 'Please define where the sensor is located on the map.',
    pt: 'Defina onde o sensor está localizado no mapa.',
  },
  location_sensor: {
    de: 'Die Position des Sensors ist',
    en: 'The location of the sensor is',
    pt: 'A localização do sensor é',
  },
  change_location_plant: {
    de: 'Position in der Anlage ändern',
    en: 'Change location in the plant',
    pt: 'Alterar a localização na planta',
  },
  location_map: {
    de: 'Standort auf der Karte',
    en: 'Location on the map',
    pt: 'Localização no mapa',
  },
  location_map_hint: {
    de: 'Bitte klicken Sie auf den Button und geben Sie an wo sich der Sensor auf der Karte befindet.',
    en: 'Please, click the button below and indicate where the sensor is located on the map.',
    pt: 'Clique no botão abaixo e indique onde o sensor está localizado no mapa.',
  },
  set_location_map: {
    de: 'Standort auf der Karte setzen',
    en: 'Set location on the map',
    pt: 'Definir localização no mapa',
  },
  change_location_map: {
    de: 'Standort ändern',
    en: 'Edit location',
    pt: 'Editar localização',
  },

  ultrasonic_check: {
    de: 'Ultraschallkontrolle',
    en: 'Ultrasonic check',
    pt: 'Verificação ultrassônica',
  },
  perform_check: {
    de: 'Optional können Sie die Daten einer durchgeführten Ultraschallprüfung hinzufügen.',
    en: 'Optionally, you can add the data of a performed Ultrasonic check.',
    pt: 'Opcionalmente, você pode adicionar os dados de uma verificação ultrassônica realizada.',
  },
  ultrasonic_check_done: {
    de: 'Ultraschallprüfdaten hinzufügen',
    en: 'Add Ultrasonic check data',
    pt: 'Adicionar dados de verificação ultrassônica',
  },
  add_sensor_based_on_ultrasonic_toggle: {
    de: 'Andernfalls klicken Sie auf speichern und beenden.',
    en: 'Otherwise click save and finish',
    pt: 'Caso contrário, clique em salvar e concluir',
  },
  enter_data_based_on_ultrasonic_toggle: {
    de: 'Bitte geben Sie die Daten ein',
    en: 'Please enter the data',
    pt: 'Insira os dados',
  },
  decibel_rating: {
    de: 'Dezibel-Wert',
    en: 'Decibel rating',
    pt: 'Classificação de decibéis',
  },

  decibel_rating_hint: {
    de: 'Bitte notieren Sie den tatsächlichen Dezibelwert des Ultraschallgeräts:',
    en: 'Please write down the actual decibel reading from the ultrasonic device:',
    pt: 'Anote a leitura real de decibéis do dispositivo ultrassônico',
  },
  numbersbetween1and140Allowed: {
    de: 'Nur Zahlen zwischen 1 - 140 erlaubt',
    en: 'Only numbers between 1 - 140 allowed',
    pt: 'Somente números entre 1 e 140 são permitidos',
  },
  postiveValuesAllowed: {
    de: 'Nur positive Werte erlaubt',
    en: 'Only positive values allowed',
    pt: 'Somente valores positivos são permitidos',
  },
  decimalNumbersNotAllowed: {
    de: 'Dezimalzahlen nicht zulässig',
    en: 'Decimal numbers not allowed',
    pt: 'Números decimais não permitidos',
  },
  inlet_outlet_temperature: {
    de: 'Eingang- und Ausgangtemperatur',
    en: 'Inlet & outlet temperature',
    pt: 'Temperatura de entrada e saída',
  },
  inlet_outlet_temperature_desc: {
    de: 'Bitte messen Sie die Temperaturen nach dem Einbau des Sensors und geben Sie diese an:',
    en: 'Please measure and state the temperatures after sensor installation:',
    pt: 'Por favor, faça a medição e informe as temperaturas após a instalação do sensor',
  },
  current_inlet_temp: {
    de: 'Aktuelle Eingangstemperatur',
    en: 'Current Inlet temperature',
    pt: ' Temperatura atual de entrada',
  },
  current_outlet_temp: {
    de: 'Aktuelle Ausgangstemperatur',
    en: 'Current Outlet temperature',
    pt: ' Temperatura atual de saída',
  },
  add_note_optional: {
    de: 'Notiz hinzufügen (optional)',
    en: 'Add a note (optional)',
    pt: 'Adicione uma observação (opcional)',
  },
  add_note_optional_hint: {
    de: 'Bitte fügen Sie hier eventuelle Beobachtungen ein:',
    en: 'Please note down any observations in the below field:',
    pt: 'Anote quaisquer observações no campo abaixo:',
  },
  type_here: { de: 'Hier eingeben', en: 'Type here', pt: 'Digite aqui' },
  sensor_success: {
    de: 'Der Sensor wurde erfolgreich verbunden',
    en: 'The sensor has been connected successfully',
    pt: 'O sensor foi conectado com sucesso',
  },
  match_sensor_success: {
    de: 'Ihre Equipment wurde erfolgreich abgeglichen',
    en: 'Your equipment has been matched successfully',
    pt: 'Seu equipamento foi correspondido com sucesso',
  },
  match_sen: {
    de: 'Equipment',
    en: 'Equipment',
    pt: 'Equipamento',
  },
  match_connect: {
    de: 'Der Anschluss der Geräte stimmt überein.',
    en: 'The connection of the equipment matches.',
    pt: 'A conexão do equipamento corresponde.',
  },
  allow_push_notifications: {
    de: 'Alle Push-Benachrichtigungen zulassen',
    en: 'Allow all push notifications',
    pt: 'Allow all push notifications',
  },
  allow_email_notifications: {
    de: 'Alle Emails zulassen',
    en: 'Allow all emails',
    pt: 'Permitir todos os e-mails',
  },
  sensor: { de: 'Sensor', en: 'Sensor', pt: 'Sensor' },
  sensor_success_hint: {
    de: 'wurde erfolgreich mit LOCTITE Pulse verbunden',
    en: 'has  been successfully connected to LOCTITE Pulse.',
    pt: 'foi conectado com sucesso ao LOCTITE Pulse.',
  },
  go_back: { de: 'Zurück', en: 'Go back', pt: 'Voltar' },
  continue: { de: 'Weiter', en: 'Continue', pt: 'Continuar' },
  back_to: { de: 'Zurück zu ', en: 'Back to ', pt: 'Voltar para ' },
  back_to_plant: {
    de: 'Zurück zur Anlage',
    en: 'Go back to plant',
    pt: 'Voltar para a planta',
  },
  back_to_nav: {
    de: 'Zurück zur Navigation',
    en: 'Back to navigation',
    pt: 'Voltar para a navegação',
  },
  nav_upload_photo: {
    de: 'Foto hinzufügen',
    en: 'Upload photo',
    pt: 'Carregar foto',
  },
  nav_take_or_upload_photo: {
    de: 'Foto ändern',
    en: 'Change photo',
    pt: 'Alterar foto',
  },
  upload_photo_button: {
    de: 'Ein Foto hochladen',
    en: 'Upload a photo',
    pt: 'Carregar uma foto',
  },
  upload_photo_button_mobile: {
    de: 'Ein Foto hinzufügen',
    en: 'Take a photo',
    pt: ' Tirar uma foto',
  },
  back_to_sensor: {
    de: 'Zurück zum Sensor',
    en: 'Back to connect sensor',
    pt: 'Voltar para conectar o sensor',
  },
  back_to_edge: {
    de: 'Zurück zum Edge Device',
    en: 'Back to match edge device',
    pt: 'Voltar para corresponder ao dispositivo de borda',
  },
  set_location: {
    de: 'Standort setzen',
    en: 'Set location',
    pt: 'Definir localização',
  },
  confirm_sensor_position: {
    de: 'Sensorposition bestätigen',
    en: 'Confirm sensor position',
    pt: 'Confirmar a posição do sensor',
  },
  confirm_position_sensor: {
    de: 'Position des Sensors bestätigen',
    en: 'Confirm the position of the sensor',
    pt: 'Confirmar a posição do sensor',
  },
  confirm_image_crop: {
    de: 'Zuschneidebereich verschieben um das Foto anzupassen',
    en: 'Move crop area to adjust the photo',
    pt: 'Mover a área de corte para ajustar a foto',
  },
  confirm_image_crop_scan: {
    de: 'Bitte schneiden Sie den Bereich so zu, dass nur der QR/Matrix Code sichtbar ist',
    en: 'Please scale and move the crop area so the only visible elements is the QR/Matrix code',
    pt: 'Dimensione e mova a área de corte para que os únicos elementos visíveis sejam o código QR/Matriz',
  },
  confirm_location: {
    de: 'Position bestätigen',
    en: 'Confirm location',
    pt: 'Confirmar localização',
  },
  back_to_photo: {
    de: 'Zurück zu Foto hochladen',
    en: 'Back to upload photo',
    pt: 'Voltar para carregar a foto',
  },
  finish_sensor: {
    de: 'Speichern und Fertigstellen',
    en: 'Save and finish',
    pt: 'Salvar e finalizar',
  },
  sensor_qr_code: {
    de: 'QR Code des Sensors',
    en: 'Sensor QR code',
    pt: 'Código QR do sensor',
  },
  sensor_example: {
    de: 'Beispielfoto Sensor',
    en: 'Example of sensor photo',
    pt: 'Exemplo de foto do sensor',
  },
  drag_pin: {
    de: 'Ziehen Sie den Pin auf die richtige Stelle um die Position des Sensors auf dem Foto zu markieren',
    en: 'Drag the pin to mark the right position of the sensor',
    pt: 'Arraste o pino para marcar a posição correta do sensor',
  },
  qr_code_invalid: {
    de: 'Der gescannte QR Code ist ungültig.',
    en: 'An invalid QR code has been scanned.',
    pt: 'Um código QR inválido foi escaneado.',
  },
  qr_code_first_time_error: {
    de: 'Es ist ein Problem mit der Kamera aufgetreten. Versuchen Sie es erneut, laden Sie ein Bild des Codes hoch oder geben Sie ihn manuell ein.',
    en: 'A problem has occurred with the camera. Try again, upload a picture of the code or enter it manually.',
    pt: 'Ocorreu um problema com a câmera. Tente novamente, carregue uma imagem do código ou insira-o manualmente.',
  },
  qr_code_error: {
    de: 'Beim Scannen des QR Codes ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    en: 'There was a problem scanning the QR code, please try again.',
    pt: 'Ocorreu um problema na leitura do código QR, tente novamente.',
  },
  create_sensor_title: {
    de: 'Neuen Sensor hinzufügen',
    en: 'Add new sensor',
    pt: 'Adicionar novo sensor',
  },
  sensor_qr_instruction_1: {
    de: 'Der QR Code des Sensors befindet sich auf dem Label am Kabel des Sensors.',
    en: "The sensor's QR code is located on a label attached to the sensor cable.",
    pt: 'O código QR do sensor está localizado em uma etiqueta anexada ao cabo do sensor.',
  },
  sensor_qr_instruction_2: {
    de: 'Auf dem Label befinden sich der QR Code und die 11 Ziffern des Sensors.',
    en: 'On the label is the QR code and the 11 digits of the sensor.',
    pt: 'Na etiqueta estão o código QR e os 11 dígitos do sensor.',
  },
  sensor_qr_instruction_3: {
    de: 'Der QR Code des Edge Devices befindet sich auf der Rückseite des Geräts.',
    en: 'The QR code of the edge device is located on the back of the device.',
    pt: 'O código QR do dispositivo de borda está localizado na parte traseira do dispositivo.',
  },
  where_is_the_sensor: {
    de: 'Wo befindet sich der Sensor?',
    en: 'Where is the sensor located?',
    pt: 'Onde está localizado o sensor?',
  },
  street_or_building: {
    de: 'Geben Sie eine Straße oder ein Gebäude ein',
    en: 'Type a street or building',
    pt: 'Digite uma rua ou um prédio',
  },
  show_sensors: {
    de: 'Sensoren zeigen',
    en: 'Show sensors',
    pt: 'Mostrar sensores',
  },
  satellite_view: {
    de: 'Satellitenansicht',
    en: 'Satellite View',
    pt: 'Visualização de satélite',
  },
  map_view: { de: 'Kartenansicht', en: 'Map View', pt: 'Visão do Mapa' },
  set_location_on_map: {
    de: 'Standort auf Karte setzen',
    en: 'Set location on map',
    pt: 'Definir localização no mapa',
  },
  to_sensor_in_EM: {
    de: 'Zum Sensor in Equipment Monitor',
    en: 'Go to sensor in Equipment Monitor',
    pt: 'Ir para o sensor no Monitor de equipamentos',
  },
  to_EM: {
    de: 'Zum Equipment Monitor',
    en: 'Go to Equipment Monitor',
    pt: 'Ir para o Monitor de equipamentos',
  },
  //banner-maintenance

  banner_heading_maintenance: {
    de: 'Wir nehmen einige Verbesserungen vor.',
    en: 'We´re making some improvements.',
    pt: 'Estamos fazendo algumas melhorias.',
  },
  banner_maintenance_text1: {
    de: 'Vielen Dank für Ihre Geduld. Unsere App wird derzeit einer planmäßigen Wartung unterzogen, um Ihre Erfahrung zu verbessern. Ihre Anlagen werden weiterhin überwacht und wir werden Sie bei Bedarf direkt kontaktieren.',
    en: 'Thank you for your patience. Our app is currently undergoing scheduled maintenance to improve your experience. Your assets are still being monitored and we´ll contact you directly if needed.',
    pt: 'Obrigado por sua paciência. Nosso aplicativo está passando por manutenção programada para melhorar sua experiência. Seus equipamentos ainda estão sendo monitorados e entraremos em contato diretamente com você, se necessário.',
  },
  banner_maintenance_text2: {
    de: 'Bitte haben Sie Geduld mit uns, während wir daran arbeiten, den Dienst wieder zum Laufen zu bringen.',
    en: 'Please bear with us as we work to bring the service back up and running.',
    pt: 'Tenha paciência conosco enquanto trabalhamos para que o serviço volte a funcionar.',
  },

  // Sensor Creation V2
  inlet_sensor: {
    de: 'Sensor in Loctite Pulse registrieren: Eingang',
    en: 'Register sensor: INLET',
    pt: 'Registrar sensor INLET',
  },
  inlet_sensor_color_assignment: {
    de: 'Farbzuordnung Sensor: EINGANG',
    en: 'Color assignment Sensor: INLET',
    pt: 'Atribuição de cores Sensor: INLET',
  },
  outlet_sensor_color_assignment: {
    de: 'Farbzuordnung Sensor: AUSGANG',
    en: 'Color assignment Sensor: OUTLET',
    pt: 'Sensor de atribuição de cor: OUTLET',
  },
  register_hint_inlet: {
    de: 'Zuerst müssen wir den QR Code für dein Eingang-Sensor scannen. Sie finden den QR Code auf dem Kabel.',
    en: 'Please scan the QR code of the INLET',
    pt: 'Leia o código QR do INLET',
  },
  register_hint_inlet_color: {
    de: 'Bitte wählen Sie die Farbe aus, die Sie von dem DAU an die Eingangssensoren angeschlossen haben.',
    en: 'Please select the color which you have connected from the DAU to the inlet sensors.',
    pt: 'Selecione a cor que você conectou da DAU aos sensores de entrada.',
  },
  register_hint_outlet_color: {
    de: 'Bitte wählen Sie die Farbe aus, die Sie von dem DAU an die Ausgangssensoren angeschlossen haben.',
    en: 'Please select the color which you have connected from the DAU to the outlet sensors.',
    pt: 'Selecione a cor que você conectou da DAU aos sensores de saída.',
  },
  choose_right_color: {
    de: 'Wie Sie die richtige Farbe auswählen',
    en: 'How to choose the right color',
    pt: 'Como escolher a cor certa',
  },
  select_model_number: {
    de: 'Modellnummer auswählen:',
    en: 'select the model number:',
    pt: 'Selecione o número do modelo',
  },
  enter_model_number: {
    de: 'Bitte geben Sie die Modellnummer ein',
    en: 'Please enter the model number',
    pt: 'Digite o número do modelo',
  },
  model_number: {
    de: 'Modellnummer ein:',
    en: 'Model number:',
    pt: 'Número do modelo',
  },
  select_dau_model_number: {
    de: 'Wählen Sie eine Modellnummer',
    en: 'Select a model number',
    pt: 'Selecione um número de modelo',
  },
  enter_code_serial_number: {
    de: 'die 10-stellige Seriennummer einfügen:',
    en: 'enter the 10 digits of the serial number:',
    pt: 'insira os 10 dígitos do número de série:',
  },
  inlet_sensor_qr_instruction_step1: {
    de: 'Identifizieren Sie als Nächstes das Sensoreingangskabel. Es ist durch',
    en: 'Next, identify the sensor inlet cable. It is indicated by',
    pt: 'Em seguida, identifique o cabo de entrada do sensor. Ele é indicado por',
  },
  inlet_sensor_qr_instruction: {
    de: 'Identifizieren Sie zunächst die Einlass-Seite des Kondensatableiters. Auf dem Kondensatableiter selbst befindet sich ein Pfeil, der die Durchflussrichtung anzeigt. Der Pfeil zeigt auf die Auslass-Seite. Die gegenüberliegende Seite des Pfeils ist also die Einlass-Seite.',
    en: 'First, identify the inlet side of the steam trap. There is an arrow on the steam trap itself which shows the direction of flow. The arrow points to the outlet side. So, the opposite side of this is the inlet side.',
    pt: 'Primeiro, identifique o lado de entrada do purgador de vapor. Há uma seta no próprio purgador que mostra a direção do fluxo. A seta aponta para o lado da saída. Portanto, o lado oposto a esse é o lado da entrada.',
  },
  inlet_sensor_qr_instruction_step2: {
    de: 'einen',
    en: 'one',
    pt: 'um',
  },
  inlet_sensor_qr_instruction_step3: {
    de: 'weißen Ring gekennzeichnet.',
    en: 'white ring.',
    pt: 'anel branco.',
  },
  inlet_sensor_qr_code: {
    de: 'QR Code für Eingang',
    en: "INLET's QR code",
    pt: 'Código QR do INLET',
  },
  choose_right_color_popup: {
    de: 'Erklärung der Farbzuordnung',
    en: 'Color assignment explanation',
    pt: 'Explicação da atribuição de cores',
  },
  choose_right_color_popup_2: {
    de: 'Um eine Struktur zu erhalten und auf einen Blick zu sehen, was am Eingang und was am Ausgang programmiert wurde, empfehlen wir Ihnen, immer die gleichen Farbzuordnungen zu verwenden.',
    en: 'In order to maintain a structure and to see at a glance what has been programmed at the inlet and what at the outlet, we recommend that you always use the same color assignments.',
    pt: 'Para manter uma estrutura e ver rapidamente o que foi programado na entrada e o que foi programado na saída, recomendamos que você use sempre as mesmas atribuições de cores.',
  },
  inlet_model_selection_info: {
    de: 'Bitte beachten Sie, dass bei der Installation und dem Anschluss eines Sensors auf der Eingang-Seite nur Sensormodelle mit dem Code A-SE-23-0002 verwendet werden können.',
    en: 'Please note when installing and connecting a sensor on the INLET side, only sensor models with the code A-SE-23-0002 can be used.',
    pt: 'Observe que ao instalar e conectar um sensor no lado do INLET, somente modelos de sensores com o código A-SE-23-0002 podem ser usados.',
  },
  qr_successfully_scanned_inlet: {
    de: 'QR Code am Eingang-Sensor erfolgreich gescannt',
    en: 'QR code on sensor INLET successfully scanned',
    pt: 'Código QR code no  sensor INLET escaneado com sucesso (Código QR on sensor INLET escaneado com sucesso)',
  },
  qr_successfully_entered_inlet: {
    de: 'QR Code am Eingang-Sensor erfolgreich eingegeben',
    en: 'QR code on sensor INLET successfully entered',
    pt: 'Código QR no sensor INLET inserido com sucesso',
  },
  qr_model_no_invalid_inlet: {
    de: 'Ungültige Modellnummer für den Eingang-Sensor',
    en: 'Invalid sensor model no. for inlet sensor',
    pt: 'Número de modelo de sensor inválido para o sensor de entrada',
  },
  outlet_sensor: {
    de: 'Sensor in Loctite Pulse registrieren: Ausgang',
    en: 'Register sensor: OUTLET',
    pt: 'Registre o sensor OUTLET',
  },
  register_hint_outlet: {
    de: 'Zuerst müssen wir den QR Code für dein Ausgang-Sensor scannen. Sie finden den QR Code auf dem Kabel.',
    en: 'Please scan the QR code of the OUTLET',
    pt: 'Por favor, escaneie o código QR do OUTLET',
  },
  outlet_sensor_qr_instruction: {
    de: 'Bestimmen Sie zunächst die Auslass-Seite des Kondensatableiters. Auf dem Kondensatableiter selbst befindet sich ein Pfeil,der die Durchflussrichtung anzeigt. Der Pfeil zeigt auf die Auslass-Seite.',
    en: 'First, identify the outlet side of the steam trap. There is an arrow on the steam trap itself which shows the direction of flow. The arrow points to the outlet side.',
    pt: 'Primeiro, identifique o lado da saída do purgador de vapor. Há uma seta no próprio purgador que mostra a direção do fluxo. A seta aponta para o lado da saída.',
  },
  outlet_sensor_qr_instruction_step1: {
    de: 'Als Nächstes identifizieren Sie das Sensorausgangskabel. Es ist durch',
    en: 'Next, identify the sensor outlet cable. It is indicated by',
    pt: 'Em seguida, identifique o cabo de saída do sensor. Ele é indicado por',
  },
  outlet_sensor_qr_instruction_step2: {
    de: 'zwei',
    en: 'two',
    pt: 'dois',
  },
  outlet_sensor_qr_instruction_step3: {
    de: 'weiße Ringe gekennzeichnet.',
    en: 'white rings.',
    pt: 'anéis brancos.',
  },
  outlet_sensor_qr_code: {
    de: 'QR Code für Ausgang',
    en: "OUTLET's QR code",
    pt: 'Código QR do OUTLET',
  },
  qr_successfully_scanned_outlet: {
    de: 'QR Code am Ausgang-Sensor erfolgreich gescannt',
    en: 'QR code on sensor OUTLET successfully scanned',
    pt: 'QR code do sensor OUTLET scaneado com sucesso',
  },
  qr_successfully_entered_outlet: {
    de: 'QR Code am Ausgang-Sensor erfolgreich eingegeben',
    en: 'QR code on sensor OUTLET successfully entered',
    pt: 'QR code do sensor OUTLET adicionado com sucesso',
  },
  qr_model_no_invalid_outlet: {
    de: 'Ungültige Modellnummer für den Ausgang-Sensor',
    en: 'Invalid sensor model no. for outlet sensor',
    pt: 'Número de modelo de sensor inválido para o sensor de saída',
  },

  ten_characters: {
    de: 'Genau 10 Zeichen',
    en: 'Exactly 10 characters',
    pt: 'Exatamente 10 caracteres',
  },
  alphanumeric: {
    de: 'Sonderzeichen nicht erlaubt',
    en: 'Special characters not allowed',
    pt: 'Caracteres especiais não permitidos',
  },
  first_two_chars_alphabet: {
    de: 'Die ersten beiden Zeichen sollten Buchstaben und/oder Zahlen sein',
    en: 'First two characters should be letters and/or numbers',
    pt: 'Os dois primeiros caracteres devem ser letras e/ou números',
  },

  match_equipment: {
    de: '1. Gerät zuordnen',
    en: '1. Match your equipment',
    pt: '1. Associe o seu equipamento',
  },
  test_plant: {
    de: 'Test Plant',
    en: 'Test Plant',
    pt: 'Planta de teste',
  },
  test_pump: {
    de: 'Test Pump',
    en: 'Test Pump',
    pt: 'Bomba Teste',
  },

  // Asset Navigation
  asset_navigation: { de: 'Navigation', en: 'Navigation', pt: 'Navegação' },

  // Settings
  settings: {
    de: 'Weitere Informationen',
    en: 'More information',
    pt: 'Mais informações',
  },
  notifications: {
    de: 'Benachrichtigungen',
    en: 'Notifications',
    pt: 'Notificações',
  },
  notificationsflange: {
    de: 'Benachrichtigungen Flansch',
    en: 'Flange Notifications',
    pt: 'Notificações de Flange',
  },
  notificationspipe: {
    de: 'Benachrichtigungen Rohrleitung',
    en: 'Pipe Notifications',
    pt: 'Notificações de tubulação',
  },
  notificationssteamtrap: {
    de: 'Benachrichtigungen Kondensatableiter',
    en: 'Steam Trap Notifications',
    pt: 'Notificações de purgador de vapor',
  },
  steam_trap_blow_through: {
    de: 'Durchblasen',
    en: 'Blow through',
    pt: 'Sopro através de',
  },
  steam_trap_blocked: {
    de: 'Blockiert',
    en: 'Blocked',
    pt: 'Bloqueado',
  },
  technical_documents: {
    de: 'Technische Dokumente',
    en: 'Technical documents',
    pt: 'Documentos técnicos',
  },
  view_technical_documents: {
    de: 'Technische Dokumente ansehen',
    en: 'View technical documents',
    pt: 'Exibir documentos técnicos',
  },
  technical_documents_smart_flange: {
    de: 'Technische Dokumente für Smart Flange',
    en: 'Technical documents for Smart Flange',
    pt: 'Documentos técnicos para Smart Flange',
  },
  technical_documents_steamtrap: {
    de: 'Technische Dokumente für Kondensat-ableiter',
    en: 'Technical documents for Steam Trap',
    pt: 'Documentos técnicos para purgador de vapor',
  },
  technical_documents_rotatingequipment: {
    de: 'Technische Dokumente für rotierende Geräte',
    en: 'Technical documents for Rotating Equipment',
    pt: 'Documentos técnicos para equipamentos rotativos',
  },
  doctype_label_product: {
    de: 'Produktdatenblatt (Englisch)',
    en: 'Product Description Sheet',
    pt: 'Folha de descrição do produto',
  },
  select_language: {
    de: 'Sprache auswählen',
    en: 'Select language',
    pt: 'Selecionar idioma',
  },
  doctype_label_manual: {
    de: 'Bedienungsanleitung (Englisch)',
    en: 'Manual',
    pt: 'Manual',
  },
  show_document: {
    de: 'Dokument anzeigen',
    en: 'Show document',
    pt: 'Mostrar documento',
  },
  language: { de: 'Sprache', en: 'Language', pt: 'Idioma' },
  change_password: {
    de: 'Passwort ändern',
    en: 'Change password',
    pt: 'Alterar senha',
  },
  measurement_system: {
    de: 'Einheitensystem & Format',
    en: 'Measurement system & format',
    pt: 'Sistema e formato de medição',
  },
  help_and_support: {
    de: 'Hilfe und Support',
    en: 'Help and Support',
    pt: 'Ajuda e suporte',
  },
  imprint: {
    de: 'Impressum',
    en: 'Imprint',
    pt: 'Ficha Técnica',
  },

  logout: { de: 'Abmelden', en: 'Logout', pt: 'Sair' },
  profile: {
    de: 'Benutzerprofil',
    en: 'User profile',
    pt: 'Perfil do usuário',
  },
  profile_photo: {
    de: 'Profilfoto',
    en: 'Profile photo',
    pt: 'Foto do perfil',
  },
  personal_information: {
    de: 'Persönliche Daten',
    en: 'Personal information',
    pt: 'Informações pessoais',
  },
  apply_changes: {
    de: 'Änderungen anwenden',
    en: 'Apply changes',
    pt: 'Aplicar alterações',
  },
  appearance: { de: 'Aussehen', en: 'Appearance', pt: 'aparência' },
  changes_successful: {
    de: 'Die Änderungen wurden erfolgreich umgesetzt.',
    en: 'The changes were implemented successfully.',
    pt: 'As alterações foram implementadas com sucesso.',
  },
  changes_problem: {
    de: 'Es ist ein Problem aufgetreten und die Änderungen konnten nicht umgesetzt werden.',
    en: 'There has been a problem and the changes could not be implemented.',
    pt: 'Ocorreu um problema e as alterações não puderam ser implementadas.',
  },
  system_of_measurement: {
    de: 'Maßsystem',
    en: 'System of measurement',
    pt: 'Sistema de medição',
  },
  date_format: { de: 'Datumsformat', en: 'Date format', pt: 'Formato da data' },
  allow_push_notification: {
    de: 'Push-Benachrichtigung erlauben',
    en: 'Allow push notification',
    pt: 'Permitir notificação por push',
  },
  push_notification: {
    de: 'Push-Benachrichtigung',
    en: 'Push notification',
    pt: 'Notificação por push',
  },
  push_notification_abbrev: {
    de: 'Push-Benachr.',
    en: 'Push notif.',
    pt: 'Push notif.',
  },
  sms: {
    de: 'SMS-Benachrichtigung',
    en: 'SMS notification',
    pt: 'Notificação por SMS',
  },
  sms_abbrev: { de: 'SMS-Benachr.', en: 'SMS notif.', pt: 'SMS notif.' },
  allow_email: {
    de: 'E-Mails erlauben',
    en: 'Allow emails',
    pt: 'Permitir e-mails',
  },
  email_will_be_sent_to: {
    de: 'E-Mail wird gesendet an ',
    en: 'Email will be sent to ',
    pt: 'O e-mail será enviado para ',
  },
  warning_notifications: { de: 'Warnungen', en: 'Warnings', pt: 'Avisos' },
  about_loctite: {
    de: 'Über Loctite',
    en: 'About Loctite',
    pt: 'Sobre Loctite',
  },
  faq: { de: 'FAQ', en: 'FAQ', pt: 'FAQ' },
  your_contact: { de: 'Ihr Kontakt:', en: 'Your contact:', pt: 'Seu contato' },
  q_change_appearance: {
    de: 'Ist es möglich, das Aussehen der App zu ändern?',
    en: 'Is it possible to change the appareance of the app?',
    pt: 'É possível alterar a aparência do aplicativo?',
  },
  q_document_problem: {
    de: 'Wie kann ich ein Problem dokumentieren?',
    en: 'How can I document a problem?',
    pt: 'Como posso documentar um problema?',
  },
  q_sensor_health: {
    de: 'Was ist Sensorstatus?',
    en: 'What is sensor health?',
    pt: 'O que é a saúde do sensor?',
  },
  alerts: {
    de: 'Alarme',
    en: 'Alerts',
    pt: 'Alertas',
  },
  warnings: {
    de: 'Warnungen',
    en: 'Warnings',
    pt: 'Avisos',
  },
  terms_of_service: {
    de: 'Nutzungsbedingungen',
    en: 'Terms of use',
    pt: 'Termos de Uso do Aplicativo',
  },
  privacy_policy: {
    de: 'Datenschutzbestimmungen',
    en: 'Privacy policy',
    pt: 'Política de privacidade',
  },
  cookie_consent: {
    de: 'Cookie Zustimmung',
    en: 'Cookie Consent',
    pt: 'Cookies',
  },
  cookies_settings: {
    de: 'Cookie Einstellungen',
    en: 'Cookies Settings',
    pt: 'Configurações de cookies',
  },

  cookie_consent_first_paragraph: {
    de: 'Sofern Sie eingewilligt haben, benutzt diese Website Adobe Analytics, einen Webanalysedienst der Adobe Systems Software Ireland Limited (4-6 Riverwalk, City West Business Campus, Saggart, Dublin 24, Irland) ("Adobe"). Zu diesem Zweck wird ein Cookie auf Ihrem Endgerät installiert. Dieses Cookie sammelt Daten wie Browser- und Geräteinformationen, Ihre IP-Adresse, besuchte Webseiten sowie Datum und Uhrzeit der Serveranfrage, um Ihr Nutzerverhalten unserer Webseite auszuwerten, um Berichte über die Webseitenaktivität für Webseitenbetreiber zu erstellen und um weitere mit der Webseitennutzung und der Internetnutzung verbundene Dienstleistungen gegenüber dem Webseitenbetreiber zu erbringen.',
    en: 'Provided you have consented, this website uses Adobe Analytics, a web analytics service provided by Adobe Systems Software Ireland Limited (4-6 Riverwalk, City West Business Campus, Saggart, Dublin 24, Ireland) (“Adobe”). For this purpose, a cookie is installed on your device. This cookie will collect data such as browser and device information, your IP address, visited websites, and date and time of server request for the purpose of evaluating your use of the website, compiling reports on website activity for website operators and providing other services relating to website activity and internet usage to the website provider.',
    pt: 'Este Aplicativo Loctite Pulse utiliza os chamados cookies. Cookies são pequenas unidades de dados temporariamente armazenadas em seu dispositivo final e que são necessárias para o uso do Aplicativo Loctite Pulse. Os cookies frequentemente contêm um identificador anônimo gerado aleatoriamente. Alguns desses identificadores são excluídos ao final da sessão do Aplicativo Loctite Pulse; outros permanecem em seu dispositivo final por mais tempo.',
  },

  cookie_consent_second_paragraph: {
    de: 'Adobe (als für die Verarbeitung Verantwortlicher) kann Ihre Daten für eigene Zwecke wie die Profilerstellung und die Verknüpfung Ihrer Daten mit anderen über Sie erhobenen Daten (z. B. über Ihr Adobe-Konto) nutzen.',
    en: 'Adobe (as a controller) may use your data for any own purposes as for profiling and linking your data to other data collected about you (e.g. through your Adobe Account).',
    pt: 'Além dos cookies estritamente necessários (utilizados, por exemplo, para permitir seu login e assegurar a segurança), o Aplicativo Loctite Pulse utiliza cookies de análise / desempenho e tecnologias similares, em particular o Adobe Analytics, para medir e analisar o uso.',
  },

  cookie_consent_third_paragraph: {
    de: 'Die durch das Cookie erzeugten Informationen über Ihre Webseitennutzung (einschließlich Ihrer IP-Adresse) werden an einen Server von Adobe in das Vereinigte Königreich übertragen und dort verarbeitet. Für diese Datenübermittlung in ein Drittland wird gemäß Art. 46 DSGVO ein angemessenes Datenschutzniveau durch Standardvertragsklauseln sichergestellt, darüber hinaus existiert für das Vereinigte Königreich ein Angemessenheitsbeschluss der Europäischen Kommission (Art. 45 DSGVO).',
    en: 'The information generated by the cookie about your use of the website (including your IP address) will be transmitted to and processed by Adobe on servers in the United Kingdom. For this third country data transfer, an adequate level of data protection is ensured by standard contractual clauses, Art. 46 GDPR, pending an adequacy decision by the European Commission (Art. 45 GDPR).',
    pt: 'Os cookies estritamente necessários são utilizados com base no interesse legítimo da Henkel na adequada disponibilização do Aplicativo.',
  },

  cookie_consent_fourth_paragraph: {
    de: 'Wir haben die IP-Anonymisierung aktiviert, sodass das letzte Oktett (der letzte Teil) der IP-Adresse sofort unkenntlich gemacht wird, wenn die IP-Adresse von Adobe erfasst wird. Diese Anonymisierung wird vor jeder Verarbeitung der IP-Adresse durchgeführt. Dadurch ist lediglich nur ein ungefährer Standort zu statistischen Analysezwecken verfügbar. Nach der Geolokalisierung wird die IP-Adresse durch die generische IP-Adresse ::X.X.X.X. ersetzt.',
    en: 'We have activated the IP anonymization, which means that the last octet (the last portion) of the IP address is immediately hidden when the IP address is collected by Adobe. This anonymization is performed prior to any processing of the IP address. Only an approximate location will be available for the purpose of statistical analysis. After the geo-lookup, everywhere in Analytics the IP addresses are obfuscated – replaced with :: X.X.X.X.',
    pt: 'Os cookies de análise, incluindo o Adobe Analytics, não são estritamente necessários e somente são ativados com base em seu consentimento prévio, o qual você pode conceder ou recusar a qualquer momento por meio das configurações de cookies.',
  },

  cookie_consent_fifth_paragraph: {
    de: 'Indem Sie Cookies auf der Henkel-Webseite zulassen, erklären Sie sich mit der Nutzung der oben genannten Daten und der zuvor beschriebenen Verarbeitung durch Adobe einverstanden.\n Weitere Informationen zum Datenschutz bei Adobe-Diensten finden Sie hier: https://www.adobe.com/privacy/policy.html',
    en: 'By allowing cookies on the Henkel-website you agree to the use of the above-mentioned data and the previously described processing by Adobe.\n You find more information about privacy in Adobe services here: https://www.adobe.com/privacy/policy.html',
    pt: 'Você também pode retirar seu consentimento a qualquer momento por meio das configurações de cookies, sem prejuízo do seu uso do Aplicativo.',
  },
  cookie_consent_subtitle: {
    de: 'Widerruf der Datenerhebung:',
    en: 'Objection to data collection:',
    pt: 'Revogação da coleta de dados:',
  },
  agree_to: {
    de: 'Ich bin mit den ',
    en: 'I agree to the ',
    pt: 'Eu concordo com as ',
  },
  service_conditions: {
    de: 'Servicebedingungen',
    en: 'Service Conditions',
    pt: 'Condições Gerais de Serviço',
  },
  the: {
    de: ' und den ',
    en: ', the ',
    pt: ', o ',
  },
  app_terms_use: {
    de: 'Nutzungsbedingungen der App',
    en: 'App Terms of Use',
    pt: 'Termos de uso do aplicativo',
  },
  and_have_read: {
    de: ' einverstanden und habe die ',
    en: ' and I have read the ',
    pt: ' e li os ',
  },
  agree_to_general: {
    de: 'Ich erkläre mich mit den Allgemeinen ',
    en: 'I agree to the General ',
    pt: 'Eu concordo com o geral',
  },
  terms_and_conditon: {
    de: 'Nutzungsbedingungen einverstanden',
    en: 'Terms and Condition of Use',
    pt: 'Termos e Condições de Uso',
  },
  have_read: {
    de: 'Ich habe die Erklärung zum ',
    en: 'I have read the ',
    pt: 'Eu li a ',
  },
  data_protection_decalaration: {
    de: 'Datenschutzerklärung gelesen',
    en: 'Data Protection Declaration',
    pt: 'Declaração de Proteção de Dados',
  },
  cookies: { de: 'Cookies', en: 'Cookies', pt: 'Cookies' },
  CAPrivacyRights: {
    de: 'CA Privacy Rights',
    en: 'CA Privacy Rights',
    pt: 'CA Privacy Rights',
  },
  DSAR: {
    de: 'Do Not Sell or Share My Personal Information',
    en: 'Do Not Sell or Share My Personal Information',
    pt: 'Não vender ou compartilhar minhas informações pessoais',
  },

  name: { de: 'Vorname', en: 'Name', pt: 'Nome' },
  surname: { de: 'Nachname', en: 'Surname', pt: 'Sobrenome' },
  designation: {
    de: 'Berufsbezeichnung',
    en: 'Job Title',
    pt: 'Título do cargo',
  },
  phonenr: {
    de: 'Handynummer',
    en: 'Cell phone number',
    pt: 'Telefone celular',
  },
  error_loading_data: {
    de: 'Fehler beim Laden der Daten',
    en: 'Error loading data',
    pt: 'Erro ao carregar dados',
  },
  email: { de: 'Email', en: 'Email', pt: 'Email' },
  back_to_edit_sensor: {
    de: 'Zurück zu Sensor bearbeiten',
    en: 'Back to edit sensor',
    pt: 'Voltar para editar sensor',
  },
  back_to_edge_device_center: {
    de: 'Zurück zum Edge Device Center',
    en: 'Back to edge device center',
    pt: 'Voltar para o centro do dispositivo de borda',
  },
  back_to_signal: {
    de: 'Zurück zu Signalqualität',
    en: 'Back to signal quality',
    pt: 'Voltar para a qualidade do sinal',
  },
  back_to_battery: {
    de: 'Zurück zu Batterie',
    en: 'Back to battery',
    pt: 'Voltar para a bateria',
  },
  back: {
    de: 'Zurück',
    en: 'Back',
    pt: 'Voltar',
  },
  sensor_edited: {
    de: 'Die Änderungen wurden erfolgreich gespeichert',
    en: 'The changes have been successfully implemented',
    pt: 'As alterações foram implementadas com sucesso',
  },
  of_edge_device: {
    de: 'des Edge Device',
    en: 'of edge device',
    pt: 'do dispositivo de borda',
  },
  edge_device_battery_data: {
    de: 'Batteriedaten',
    en: 'Battery data',
    pt: 'Dados da bateria',
  },
  edge_device_signal_data: {
    de: 'Signalqualitätsdaten',
    en: 'Signal quality data',
    pt: 'Dados de qualidade do sinal',
  },
  edge_device_tilted: {
    de: 'Edge Device gekippt',
    en: 'Device tilted',
    pt: 'Device tilted',
  },
  application_type: {
    de: 'Befestigung',
    en: 'Application type',
    pt: 'Tipo de aplicativo',
  },
  edge_device_code: {
    de: 'Edge Device Code',
    en: 'Edge Device Code',
    pt: 'Código do dispositivo de borda',
  },
  ed_match_sensor_hint: {
    de: 'Scannen Sie jetzt den QR Code auf dem Edge Device um es mit dem Sensor zu verbinden.',
    en: 'Now please scan the QR code on the edge device to connect it to the sensor.',
    pt: 'Agora, leia o código QR no dispositivo de borda para conectá-lo ao sensor.',
  },
  last_page_question_1: {
    de: 'Möchten Sie einen weiteren Sensor zu diesem Equipment hinzufügen oder zurück zur Übersicht?',
    en: 'Do you want to add another sensor to the same equipment or go back to plant overview?',
    pt: 'Deseja adicionar outro sensor ao mesmo equipamento ou voltar para a visão geral da planta?',
  },
  last_page_question_2: {
    de: 'Möchten sie den installierten Sensor im Equipment Monitor anzeigen?',
    en: 'Do you want to check the installed sensor in Equipment Monitor?',
    pt: 'Deseja verificar o sensor instalado no Equipment Monitor?',
  },
  ST_last_page_question_1: {
    de: 'Möchten Sie einen neuen Sensor zu einem anderen Equipment hinzufügen oder zurück zur Übersicht?',
    en: 'Do you want to add a new sensor to another equipment or go back to plant overview?',
    pt: 'Deseja adicionar um novo sensor a outro equipamento ou voltar para a visão geral da planta?',
  },
  ST_last_page_question_2: {
    de: 'Möchten sie den installierten Sensor im Equipment Monitor anzeigen?',
    en: 'Do you want to check the installed sensor in Equipment Monitor?',
    pt: 'Deseja verificar o sensor instalado no Monitor de equipamentos?',
  },
  check_installed_sensor: {
    de: 'Im Equipment Monitor anschauen',
    en: 'Check in Equipment Monitor',
    pt: 'Verificar o monitor do equipamento',
  },
  installed_by: {
    de: 'Installiert von',
    en: 'Installed by ',
    pt: 'Instalado por ',
  },
  connectivity_error: {
    de: 'Konfiguration fehlgeschlagen',
    en: 'Configuration failure',
    pt: 'Falha de configuração',
  },
  connectivity_error_hint: {
    de: 'Bei der Konfiguration des Sensors trat ein Fehler auf. Bitte kontaktieren Sie unseren LOCTITE Pulse Tech Support:',
    en: 'There is a problem configuring the sensor. Please contact our LOCTITE Pulse tech support:',
    pt: 'Há um problema na configuração do sensor. Entre em contato com nosso suporte técnico LOCTITE Pulse:',
  },
  check_connectivity_hint: {
    de: 'Um fortzufahren, müssen wir zunächst prüfen, ob alles angeschlossen ist und einwandfrei funktioniert. Bitte warten Sie ein paar Minuten, während wir die Verbindung überprüfen.',
    en: 'To continue first we need to check that everything is connected and works perfectly. Please wait a few minutes while we check.',
    pt: 'Para continuar, primeiro precisamos verificar se tudo está conectado e funcionando perfeitamente. Aguarde alguns minutos enquanto verificamos.',
  },
  check_connectivity_prerequisites: {
    de: 'Bevor Sie die Verbindung überprüfen, stellen Sie Folgendes sicher:',
    en: 'Before checking the connectivity ensure the following:',
    pt: 'Antes de verificar a conectividade, verifique o seguinte:',
  },
  check_connectivity_prerequisite_1: {
    de: 'Das Gateway ist an das Stromnetz angeschlossen',
    en: 'Gateway is connected to power',
    pt: 'O gateway está conectado à energia',
  },
  check_connectivity_prerequisite_2: {
    de: 'Die Gateway-LED blinkt grün',
    en: 'Gateway LED is blinking green',
    pt: 'O LED do gateway está piscando em verde',
  },
  check_connectivity_prerequisite_3: {
    de: 'DAU ist eingeschaltet (zeigt links auf "LOC" von LOCTITE) und die LED blinkt grün',
    en: 'DAU is turned on (pointing left to “LOC” of LOCTITE) and LED is blinking green',
    pt: 'A DAU está ligada (apontando para a esquerda para “LOC” do LOCTITE) e o LED está piscando em verde',
  },
  check_connectivity_prerequisite_4: {
    de: 'Bitte warten Sie ein paar Minuten und klicken Sie dann auf "Konnektivität prüfen"',
    en: 'Please wait a few minutes and then click "check connectivity"',
    pt: 'Aguarde alguns minutos e, em seguida, clique em “check connectivity”',
  },
  check_connectivity_checking: {
    de: 'Verbindung wird überprüft',
    en: 'Checking connectivity',
    pt: 'Verificando a conectividade',
  },
  check_connectivity_checking_hint: {
    de: 'Warte Sie einige Minuten, während wir die Verbindung prüfen.',
    en: 'Wait a few minutes while we check that everything has been properly connected.',
    pt: 'Aguarde alguns minutos enquanto verificamos se tudo foi conectado corretamente.',
  },
  check_connectivity_success: {
    de: 'Verbindung geprüft',
    en: 'Connectivity checked',
    pt: 'Conectividade verificada',
  },
  check_connectivity_success_hint: {
    de: 'Prüfung der Verbindung erfolgreich, bitte fahren Sie fort.',
    en: 'Connectivity successfully checked, please continue the process.',
    pt: 'Conectividade verificada com sucesso, continue o processo.',
  },
  check_connectivity_gateway_error: {
    de: 'der Mobilfunkkonnektivität.',
    en: 'Connectivity issue',
    pt: 'conectividade celular.',
  },
  gateway_error: {
    de: 'Gateway - Fehler',
    en: 'Gateway - Error',
    pt: 'Gateway - Erro',
  },
  gateway_inlet: {
    de: 'Gateway - Eingang',
    en: 'Gateway - Inlet',
    pt: 'Gateway - Inlet',
  },
  gateway_outlet: {
    de: 'Gateway - Steckdose',
    en: 'Gateway - Outlet',
    pt: 'Gateway - Saída',
  },
  dau_outlet: {
    de: 'DAU - Auslass',
    en: 'DAU - Outlet',
    pt: 'DAU - Saída',
  },
  dau_inlet: {
    de: 'DAU - Eingang',
    en: 'DAU - Inlet',
    pt: 'DAU - Inlet',
  },
  dau_with_exist_gateway: {
    de: 'Diese DAU ist bereits mit dem ausgewählten Gateway verbunden ',
    en: 'This DAU is already connected to the selected gateway  ',
    pt: 'Esta DAU já está conectada ao gateway selecionado ',
  },

  /* htst outlet Dau and Gateway updation disabled till confirmation for using different gateway & Dau */
  using_same_dau_for_outlet: {
    de: 'Verwenden Sie die gleiche DAU für den Auslasssensor?',
    en: 'Are you using the same DAU for the outlet sensor?',
    pt: 'Você está usando a mesma DAU para o sensor de saída?',
  },
  using_same_gateway_for_outlet: {
    de: 'Verwenden Sie das gleiche Gateway für den Auslasssensor?',
    en: 'Are you using the same Gateway for the outlet sensor?',
    pt: 'Você está usando a mesma porta de entrada para o sensor de saída?',
  },
  /* htst outlet Dau and Gateway updation enabled till confirmation for using different gateway & Dau */
  use_same_gateway_for_outlet: {
    de: 'Bitte beachten Sie, dass Sie für den Ausgang das gleiche Gateway wie für den Eingang verwenden müssen.',
    en: 'Please be aware that you need to use the same Gateway for the outlet as you did for the inlet',
    pt: 'Esteja ciente de que você precisa usar o mesmo Gateway para a saída e para a entrada',
  },
  use_same_dau_for_outlet: {
    de: 'Bitte beachten Sie, dass Sie für den Ausgang die gleiche DAU wie für den Eingang verwenden müssen.',
    en: 'Please be aware that you need to use the same DAU for the outlet as you did for the inlet',
    pt: 'Esteja ciente de que você precisa usar o mesmo DAU para a saída e para a entrada',
  },

  /*------End--------*/
  connection_capacity_popup_title: {
    de: 'Das aktuelle DAU ist voll ausgelastet. Bitte wählen Sie ein anderes, um fortzufahren.',
    en: 'Current DAU is at full capacity. Please select another to continue.',
    pt: 'O DAU atual está com sua capacidade total. Selecione outro para continuar.',
  },
  connection_capacity_gateway_popup_title: {
    de: 'Das aktuelle Gateway ist voll ausgelastet. Bitte wählen Sie ein anderes, um fortzufahren.',
    en: 'Current Gateway is at full capacity. Please select another to continue.',
    pt: 'O gateway atual está com a capacidade total. Selecione outro para continuar.',
  },
  connect_to_other_dau: {
    de: 'Verbindung zu einem anderen DAU',
    en: 'Connect to another DAU',
    pt: 'Conectar-se a outro DAU',
  },
  connect_to_other_gateway: {
    de: 'Verbindung zu einem anderen Gateway',
    en: 'Connect to another Gateway',
    pt: 'Conectar-se a outro Gateway',
  },
  check_connectivity_gateway_error_hint: {
    de: 'Wir haben Probleme, eine stabile Verbindung herzustellen.',
    en: "We're having trouble establishing a stable connection.",
    pt: 'Estamos tendo problemas para estabelecer uma conexão estável.',
  },
  check_connectivity_gateway_error_hint_2: {
    de: 'Versuchen Sie bitte die folgenden Schritte und überprüfen Sie die Verbindung erneut.',
    en: 'Please try the following steps and check connectivity again.',
    pt: 'Tente as etapas a seguir e verifique a conectividade novamente:',
  },
  check_connectivity_gateway_error_1: {
    de: 'Prüfen Sie, ob das Gateway an die Stromversorgung angeschlossen ist. Sie erkennen das an der grün blinkenden LED auf der Vorderseite vom Gateway. ',
    en: 'Check that the gateway is connected to power by checking if the green LED on the top of the gateway is blinking.',
    pt: 'Verifique se o gateway está conectado à energia verificando se o LED verde na parte superior do gateway está piscando.',
  },
  check_connectivity_gateway_error_1_moxa: {
    de: 'Prüfen Sie, ob das Kabelmodem an die Stromversorgung angeschlossen ist. ',
    en: 'Check that the gateway is connected to power.',
    pt: 'Verifique se o gateway está conectado à alimentação.',
  },
  check_connectivity_gateway_error_i: {
    de: 'Wenn Sie das Gateway an die Stromversorgung anschließen, dauert es einige Zeit, bis es hochfährt und die Verbindung hergestellt ist.',
    en: '( Keep in mind when you connect the gateway to power, this takes some time to start up and find connection. )',
    pt: 'Tenha em mente que quando energizar o gateway, deve se aguardar a inicialização e que encontre a conexão.',
  },
  check_connectivity_gateway_error_2: {
    de: 'Versuchen Sie, das Gateway näher an einen Außenbereich oder weg von Metall- und Betonkonstruktionen zu installieren.',
    en: 'Try to move the gateway closer to an outside area or away from metal and concrete structures.',
    pt: 'Tente mover o gateway para mais perto de uma área externa ou distante de estruturas de metal e concreto.',
  },
  check_connectivity_gateway_error_3: {
    de: 'Wenn die oben genannten Schritte nicht funktionieren, wenden Sie sich bitte an unseren technischen Support für LOCTITE Pulse: ',
    en: 'If the above steps do not work, please, contact our LOCTITE Pulse tech support: ',
    pt: 'Se as etapas acima não funcionarem, entre em contato com nosso suporte técnico LOCTITE Pulse: ',
  },
  check_connectivity_dau_error: {
    de: 'DAU Fehler',
    en: 'Error with DAU',
    pt: 'Erro com DAU',
  },
  check_connectivity_dau_error_hint_1: {
    de: 'Es gibt ein Problem beim Auffinden und Verbinden der DAU Units. ',
    en: 'There is a problem finding and connecting the DAU. ',
    pt: 'Há um problema para encontrar e conectar a DAU. ',
  },
  check_connectivity_dau_error_hint_2: {
    de: 'Bitte wenden Sie sich an unseren technischen Support für LOCTITE Pulse: ',
    en: 'Please contact our LOCTITE Pulse tech support: ',
    pt: 'Entre em contato com o suporte técnico de  LOCTITE Pulse: ',
  },
  loctite_support_mail: {
    de: 'service@loctite-pulse.com',
    en: 'service@loctite-pulse.com',
    pt: 'service@loctite-pulse.com',
  },
  map_gesture_touch: {
    de: 'Verwenden Sie zwei Finger zum Bewegen der Karte',
    en: 'Use two fingers to move the map',
    pt: 'Use dois dedos para mover o mapa',
  },
  map_gesture_scroll: {
    de: 'Verwenden Sie Strg + Scrollen zum Zoomen der Karte',
    en: 'Use ctrl + scroll to zoom the map',
    pt: 'Use ctrl + rolar para ampliar o mapa',
  },
  map_gesture_scroll_mac: {
    de: 'Verwenden Sie \u2318 + Scrollen zum Zoomen der Karte',
    en: 'Use \u2318 + scroll to zoom the map',
    pt: 'Use \u2318 + rolagem para ampliar o mapa',
  },
  scan_popup_title: {
    de: 'Was möchten Sie tun?',
    en: 'What do you want to do?',
    pt: 'O que você quer fazer?',
  },
  scan_the_code: {
    de: 'Code scannen',
    en: 'Scan the code',
    pt: 'Digitalize o código',
  },
  upload_the_code: {
    de: 'Code hochladen',
    en: 'Upload the code',
    pt: 'Fazer upload do código',
  },
  wait_for_qr_code: {
    de: 'Bitte warten Sie ein paar Sekunden, während der QR Code gescannt wird.',
    en: 'Wait a few seconds while the QR code is being scanned.',
    pt: 'Aguarde alguns segundos enquanto o código QR está sendo escaneado.',
  },
  scanning_qr_code: {
    de: 'QR Code wird gescannt',
    en: 'Scanning QR code',
    pt: 'Leitura de código QR',
  },
  scanning_matrix_code: {
    de: 'Matrix Code wird gescannt',
    en: 'Scanning matrix code',
    pt: 'Leitura de código de matriz',
  },
  wait_for_matrix_code: {
    de: 'Bitte warten Sie ein paar Sekunden, während der Matrixcode gescannt wird.',
    en: 'Wait a few seconds while the matrix code is being scanned.',
    pt: 'Aguarde alguns segundos enquanto o código de matriz está sendo digitalizado.',
  },
  matrix_code_error: {
    de: 'Beim Scannen des Matrix Codes ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    en: 'There was a problem scanning the matrix code, please try again.',
    pt: 'Houve um problema na leitura do código de matriz, tente novamente.',
  },
  match_rotating_equipment_not_allowed: {
    en: 'To match the equipment with the new sensor, please contact your sales representative.',
    de: 'Um die Ausrüstung an den neuen Sensor anzupassen, wenden Sie sich bitte an Ihren Vertriebsmitarbeiter.',
    pt: 'Para combinar o equipamento com o novo sensor, entre em contato com seu representante de vendas.',
  },
  confirm: {
    de: 'Bestätigen',
    en: 'Confirm',
    pt: 'Confirmar',
  },
  subscription_details: {
    de: 'Abonnement Details',
    en: 'Subscription details',
    pt: 'Detalhes da assinatura',
  },
  subscription_details_name: {
    de: 'NAME',
    en: 'NAME',
    pt: 'NOME',
  },
  subscription_details_start_date: {
    de: 'STARTDATUM',
    en: 'START DATE',
    pt: 'DATA DE INÍCIO',
  },
  subscription_details_end_date: {
    de: 'ENDDATUM',
    en: 'END DATE',
    pt: 'DATA DE TÉRMINO',
  },
  subscription_details_edit_hint: {
    de: 'Bitte wählen Sie aus der folgenden Liste der Abonnements aus.',
    en: 'Please select from the list of subscriptions below.',
    pt: 'Por favor, selecione da lista de assinaturas abaixo.',
  },
  subscription_details_loading_error: {
    de: 'Fehler beim Laden der Abonnement-Informationen',
    en: 'Error loading subscription information',
    pt: 'Erro ao carregar as informações da assinatura',
  },
  subscription_list_empty: {
    de: 'Keine Verfügbaren Abonnements gefunden',
    en: 'No available subscriptions found',
    pt: 'Nenhuma assinatura disponível encontrada',
  },
  no_subscription_hint: {
    de: 'Bitte fügen Sie über "Sensor bearbeiten" einen Abonnementnamen hinzu, um ihn hier anzuzeigen.',
    en: 'Please add a subscription name via "Edit Sensor" to display it here.',
    pt: 'Por favor, adicione um nome de assinatura através de "Editar Sensor" para exibi-lo aqui.',
  },
  subscription_popup_hint: {
    de: 'Möchten Sie, dass diese Abonnement-ID auch auf alle anderen Sensoren in der Anlage angewendet wird?',
    en: 'Would you like this subscription ID to be applied to all other sensors in the pipe as well?',
    pt: 'Gostaria que este ID de assinatura fosse aplicado a todos os outros sensores no tubo também?',
  },
  subscription_popup_yes_btn: {
    de: 'Ja, auf alle Sensoren anwenden',
    en: 'Yes, apply to all sensors',
    pt: 'Sim, aplicar a todos os sensores',
  },
  subscription_popup_no_btn: {
    de: 'Nein, nur auf diesen Sensor',
    en: 'No, only this sensor',
    pt: 'Não, aplicar apenas a este sensor',
  },
  default_subscription_label: {
    de: 'Abbonement',
    en: 'Subscription',
    pt: 'Assinatura',
  },
  steam_loss_note_msg: {
    de: 'Wenn der "Preis pro Tonne" nicht eingegeben wird, kann die Dampfverlustberechnung im Gerätemonitor nicht anzeigt werden.',
    en: 'If the "price per ton" is not entered, we cannot display the steam loss calculation in the equipment monitor. ',
    pt: 'Se o "preço por tonelada" não for inserido, não será possível exibir o cálculo da perda de vapor no monitor do equipamento.',
  },
  steam_loss_note: {
    de: 'Bitte beachten Sie:',
    en: 'Please note: ',
    pt: 'Observação:',
  },
  // new service conditions translations

  service_conditions_title_line1: {
    de: 'Aktualisierung unserer',
    en: 'Update to our',
    pt: '',
  },

  service_conditions_title_line2: {
    de: 'Servicebedingungen',
    en: 'Service Conditions',
    pt: '',
  },

  service_conditions_description_1: {
    de: 'Wir haben unsere Servicebedingungen aufgrund neuer regulatorischer Anforderungen innerhalb der Europäischen Union aktualisiert.',
    en: "We've updated our Service Conditions to reflect new legal requirements in the European Union. Please review and accept the new terms to continue using your account.",
    pt: '',
  },

  service_conditions_description_2: {
    de: 'Bitte prüfen und akzeptieren Sie die aktualisierten Bedingungen, um Ihr Konto weiterhin uneingeschränkt nutzen zu können.',
    en: '',
    pt: '',
  },

  view_full_service_conditions: {
    de: 'Vollständige Servicebedingungen anzeigen',
    en: 'View full service conditions',
    pt: '',
  },

  accept_and_continue: {
    de: 'Akzeptieren und fortfahren',
    en: 'Accept and continue',
    pt: '',
  },

  accept_later: {
    de: 'Später akzeptieren',
    en: 'Accept later',
    pt: '',
  },
};
